<template>
  <layout
    :title="$route.name"
    :rotas="rotas"
    :options="options"
  >
    <template v-slot:toolbar-search>
      <div class="dashboard-appbar-toolbar" :class="{ dark: dark }">
        <v-btn
          depressed
          small
          class="dashboard-appbar-toolbar-btn fonte-bold"
          color="#075e54"
          dark
          @click="openDashboardWidgetMenu"
        >
          <v-icon left small>mdi-view-grid-plus-outline</v-icon>
          Widgets
        </v-btn>
        <v-btn
          depressed
          small
          class="dashboard-appbar-toolbar-btn fonte-bold"
          :color="dashboardEditMode ? '#25D366' : '#555'"
          dark
          @click="toggleDashboardEditMode"
        >
          <v-icon left small>{{ dashboardEditMode ? "mdi-content-save-outline" : "mdi-pencil-ruler" }}</v-icon>
          {{ dashboardEditMode ? "Salvar layout" : "Editar layout" }}
        </v-btn>
        <v-switch
          v-model="dark"
          :label="dark ? 'Claro' : 'Escuro'"
          :dark="dark"
          hide-details
          class="dashboard-appbar-theme-switch"
          :color="$theme.secondary"
          @change="saveStateTheme($event)"
        ></v-switch>
      </div>
    </template>

    <div
      class="expande-horizontal wrap"
      :class="{ 'pa-3': $vuetify.breakpoint.lgAndUp }"
      :style="
        `min-height: 100vh; overflow-y: auto; overflow-x: hidden; justify-content: flex-start; align-content: flex-start; background: ${
          dark ? '#222' : 'var(--background-base)'
        };`
      "
    >
      <v-flex xs12>
        <div class="pt-0 expande-horizontal column wrap">
          <div v-if="false" class="expande-horizontal" style="height: 35px;">
            <h1
              style="font-size: 17pt;"
              :class="{
                'white--text': dark,
                'black--text': !dark
              }"
              class="fonte-bold font-weight-light mb-0 ml-2 animate__animated animate__fadeInDown animate__delay-2s"
            >
              <v-avatar size="26" class="dashboard-company-logo mr-1">
                <v-img :src="dashboardCompanyLogo" contain />
              </v-avatar>
              <span class="text-uppercase">
                {{ getLoggedUser.tenant[0].nome.split(" ")[0] }}
                <!-- {{ getLoggedUser.nome.split(" ")[0] }} -->
              </span>
              <v-btn
                depressed
                class="fonte-bold mb-1 ml-1"
                color="#075e54"
                dark
                x-small
                @click="openDashboardWidgetMenu"
                >Widgets</v-btn
              >
              <v-btn
                depressed
                class="fonte-bold mb-1 ml-1"
                :color="dashboardEditMode ? '#25D366' : '#555'"
                dark
                x-small
                @click="toggleDashboardEditMode"
              >
                {{ dashboardEditMode ? "Salvar layout" : "Editar layout" }}
              </v-btn>
            </h1>
            <!-- <span
              v-if="showWelcome"
              :class="{
                'white--text': dark,
                'black--text': !dark
              }"
              style="font-size: 22pt;"
              class="message fonte-bold animate__animated animate__fadeInUp"
              >Bem vindo(a)!</span
            > -->
            <v-spacer></v-spacer>
            <!-- <span
              class="fonte-bold mt-1 mx-2"
              :class="{
                'green--text': pingTime / 2 <= 200,
                'orange--text': pingTime / 2 > 200 && pingTime / 2 <= 400,
                'red--text': pingTime / 2 > 400
              }"
              >{{ pingTime / 2 }}ms</span
            > -->

            <v-switch
              v-model="dark"
              :label="dark ? 'ðŸŒž' : 'ðŸŒœ'"
              :dark="dark"
              hide-details
              class="mr-3"
              :color="$theme.secondary"
              style="margin-top: -0px;"
              @change="saveStateTheme($event)"
            ></v-switch>
          </div>
          <!-- <v-btn
            :style="`border: 2px solid ${$theme.primary};`"
            v-if="getLoggedUser.admin"
            class="ma-3 dark-font"
            color="#e5e5e5"
            @click="$refs.modalSub.open()"
            >Ver assinatura</v-btn
          > -->
          <div
            v-if="false"
            id="container-menus"
            class="animate__animated animate__fadeIn animate__delay-1s expande-horizontal pl-2 wrap"
          >
            <v-slide-group
              :show-arrows="false"
              ref="sliderContainer"
              class="slider-container"
            >
              <v-slide-item
                v-for="(menu, index) in menus"
                v-show="menu.permission()"
                :key="`item-menu-${index}`"
              >
                <v-card
                  width="80"
                  :id="menu.name"
                  :class="
                    `${
                      menu.route === '/insumos'
                        ? `${menu.route} active-next-step`
                        : ''
                    }`
                  "
                  :color="dark ? '#444' : '#e5e5e5'"
                  class="mr-2 mb-2 py-2 px-2"
                  @click="$router.push(menu.route)"
                  :dark="dark"
                  style="border-radius: 12px;"
                >
                  <div
                    style="min-height: 60px; max-height: 60px; position: relative;"
                    class="expande-horizontal item-menu-mini column centraliza"
                  >
                    <v-icon
                      :color="dark ? $theme.secondary : $theme.primary"
                      size="26"
                      >{{ menu.icon }}</v-icon
                    >
                    <v-spacer></v-spacer>
                    <span
                      style="position: absolute; bottom: 0px;"
                      class="fonteMini text-center"
                      >{{ menu.name }}</span
                    >
                  </div>
                </v-card>
              </v-slide-item>
            </v-slide-group>
          </div>
          <!-- <div class="expande-horizontal centraliza">
            <cosmos-filter-date v-model="dateFilter"></cosmos-filter-date>
          </div> -->
          <div v-if="activeDashboardWidgets.length === 0" class="dashboard-welcome-card animate__animated animate__fadeIn" :class="{ dark: dark }">
            <div class="dashboard-welcome-copy">
              <v-avatar size="54" color="#075e54" class="mr-3">
                <v-icon dark size="28">mdi-view-dashboard-edit-outline</v-icon>
              </v-avatar>
              <div>
                <h2 class="fonte-bold mb-1">Monte sua dashboard do seu jeito</h2>
                <span class="fonte grey--text">
                  Adicione, mova e redimensione widgets para deixar os cards mais importantes sempre a mao.
                </span>
              </div>
            </div>
            <v-spacer></v-spacer>
            <v-btn rounded depressed dark color="#25D366" class="fonte-bold" @click="openDashboardWidgetMenu">
              <v-icon left>mdi-plus-box-multiple-outline</v-icon>
              Adicionar widget
            </v-btn>
          </div>

          <div class="dashboard-widget-menu-anchor" :class="{ dark: dark }">
            <v-spacer></v-spacer>
            <v-menu
              v-model="dashboardWidgetMenu"
              absolute
              :position-x="dashboardWidgetMenuPosition.x"
              :position-y="dashboardWidgetMenuPosition.y"
              offset-y
              left
              :close-on-content-click="false"
            >
              <v-card class="dashboard-widget-menu pa-2" :dark="dark" :color="dark ? '#182229' : '#fff'">
                <div class="dashboard-widget-menu-hint">
                  Clique em um item abaixo para adicionar. Depois arraste pelo cabecalho e redimensione pelo canto.
                </div>
                <v-btn block rounded small depressed color="#25D366" dark class="fonte-bold mb-2" @click="resetDashboardWidgets">
                  <v-icon left small>mdi-auto-fix</v-icon>
                  Usar layout sugerido
                </v-btn>
                <div class="fonte-bold px-2 py-1">Na dashboard</div>
                <v-list dense color="transparent" :dark="dark">
                  <v-list-item
                    v-for="(widget, index) in activeDashboardWidgets"
                    :key="`grid-active-${widget.key}`"
                  >
                    <v-list-item-avatar size="32" :color="widget.color">
                      <v-icon dark small>{{ widget.icon }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ widget.title }}</v-list-item-title>
                    </v-list-item-content>
                    <v-btn icon small :disabled="index === 0" @click="moveDashboardWidget(index, -1)">
                      <v-icon small>mdi-arrow-up</v-icon>
                    </v-btn>
                    <v-btn icon small :disabled="index === activeDashboardWidgets.length - 1" @click="moveDashboardWidget(index, 1)">
                      <v-icon small>mdi-arrow-down</v-icon>
                    </v-btn>
                    <v-btn icon small :disabled="activeDashboardWidgets.length === 1" @click="removeDashboardWidget(widget.key)">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </v-list-item>
                </v-list>
                <v-divider class="my-2"></v-divider>
                <div class="fonte-bold px-2 py-1">Adicionar widgets</div>
                <v-list dense color="transparent" :dark="dark">
                  <v-list-item
                    v-for="widget in availableDashboardWidgets"
                    :key="`grid-available-${widget.key}`"
                    @click="addDashboardWidget(widget.key)"
                    class="dashboard-add-widget-item"
                  >
                    <v-list-item-avatar size="32" :color="widget.color">
                      <v-icon dark small>{{ widget.icon }}</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content>
                      <v-list-item-title>{{ widget.title }}</v-list-item-title>
                      <v-list-item-subtitle>{{ widget.description }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-icon small>mdi-plus</v-icon>
                  </v-list-item>
                </v-list>
                <div v-if="availableDashboardWidgets.length === 0" class="pa-3 text-center grey--text fonteMini">
                  Todos os widgets ja estao na dashboard. Remova algum card para adicionar de novo.
                </div>
              </v-card>
            </v-menu>
          </div>
          <transition name="dashboard-feedback">
            <div v-if="dashboardWidgetFeedback" class="dashboard-widget-feedback">
              <v-icon color="#25D366" class="mr-2">mdi-check-circle-outline</v-icon>
              <span>{{ dashboardWidgetFeedback }}</span>
            </div>
          </transition>

          <div ref="dashboardGrid" class="grid-stack dashboard-grid-stack" :class="{ dark: dark, editing: dashboardEditMode }">
            <div
              v-for="widget in activeDashboardWidgets"
              :key="widget.key"
              class="grid-stack-item"
              :gs-id="widget.key"
              :gs-x="dashboardWidgetLayout(widget.key).x"
              :gs-y="dashboardWidgetLayout(widget.key).y"
              :gs-w="dashboardWidgetLayout(widget.key).w"
              :gs-h="dashboardWidgetLayout(widget.key).h"
              :gs-min-w="widget.minW || 3"
              :gs-min-h="widget.minH || 2"
            >
              <div class="grid-stack-item-content">
                <v-card
                  class="dashboard-modern-card pa-3"
                  :class="[`dashboard-widget-${widget.key}`, { dark: dark }]"
                  :dark="dark"
                >
                  <div class="dashboard-card-header">
                    <div class="centraliza">
                      <v-avatar size="38" :color="widget.color" class="mr-2">
                        <v-icon dark>{{ widget.icon }}</v-icon>
                      </v-avatar>
                      <div>
                        <h3 class="fonte-bold mb-0">{{ widget.title }}</h3>
                        <span class="fonteMini grey--text">{{ widget.description }}</span>
                      </div>
                    </div>
                    <v-spacer></v-spacer>
                    <v-switch
                      v-if="widget.key === 'notifications'"
                      small
                      hide-details
                      class="fonte fonteMini pa-0 ma-0 mr-2"
                      :color="$theme.primary"
                      v-model="onlyUnreadeds"
                    />
                    <v-btn v-if="dashboardEditMode" icon small @click="removeDashboardWidget(widget.key)">
                      <v-icon small>mdi-close</v-icon>
                    </v-btn>
                  </div>

                  <div v-if="widget.key === 'shortcuts'" class="dashboard-shortcuts-grid">
                    <button
                      v-for="menu in permittedMenus"
                      :key="menu.route"
                      class="dashboard-shortcut-card"
                      @click="$router.push(menu.route)"
                    >
                      <v-avatar size="42" color="#075e54">
                        <v-icon dark>{{ menu.icon }}</v-icon>
                      </v-avatar>
                      <span>{{ menu.name }}</span>
                    </button>
                  </div>

                  <div v-if="widget.key === 'paymentChart'" class="dashboard-payment-widget">
                    <div class="dashboard-payment-chart">
                      <Chart
                        :key="`${valuesPaid30Days.paymentTypes.join('|')}-${valuesPaid30Days.paymentValues.join('|')}`"
                        :dark="dark"
                        type="doughnut"
                        :backgroundColor="dashboardPaymentChartColors"
                        description="Valor"
                        :labels="valuesPaid30Days.paymentTypes"
                        :dataChart="valuesPaid30Days.paymentValues"
                        :id="'chart-grid-payment'"
                        :height="170"
                        :maintainAspectRatio="false"
                        :layoutPadding="{ top: 8, right: 8, bottom: 14, left: 8 }"
                      />
                    </div>
                    <div class="dashboard-payment-methods">
                      <div
                        v-for="(method, index) in valuesPaid30Days.paymentBreakdown"
                        :key="method.key"
                        class="dashboard-payment-method"
                      >
                        <div class="dashboard-payment-method-name">
                          <i :style="{ backgroundColor: dashboardPaymentChartColors[index] }"></i>
                          <span>{{ method.label }}</span>
                        </div>
                        <small>
                          Taxa {{ method.tax_porcentage }}% · {{ $helper.formataSaldo(method.value) }}
                        </small>
                      </div>
                    </div>
                  </div>

                  <div v-if="widget.key === 'salesChart'" class="dashboard-chart-shell">
                    <Chart
                      :dark="dark"
                      type="line"
                      backgroundColor="rgb(255, 205, 86, 0.6)"
                        description="Orçamentos"
                      :labels="salesLast30Days.days"
                      :dataChart="salesLast30Days.valuesForDays"
                      :id="'chart-grid-sales'"
                      :height="150"
                      :maintainAspectRatio="false"
                      :layoutPadding="{ top: 8, right: 14, bottom: 28, left: 8 }"
                    />
                  </div>

                  <div v-if="widget.key === 'todaySales'" class="dashboard-card-scroll">
                    <button
                      v-for="sale in salesToday"
                      :key="sale._id"
                      class="dashboard-sale-row"
                      @click="$router.push(`/gestordepedidos/venda/${sale._id}`)"
                    >
                      <div>
                        <strong>{{ sale.compra && sale.compra.cliente ? sale.compra.cliente.nome : "Cliente nao informado" }}</strong>
                        <span>{{ $helper.formataSaldo((sale.compra && sale.compra.preco_total) || 0) }}</span>
                      </div>
                      <v-chip dark x-small class="fonte-bold" :color="$theme.primary">
                        {{ $moment(sale.created_at).format("HH:mm") }}
                      </v-chip>
                    </button>
                    <div v-if="salesToday.length === 0" class="dashboard-empty-state">
                      <v-icon color="#075e54">mdi-file-document-outline</v-icon>
                      <span>Nada por hoje ainda.</span>
                    </div>
                  </div>

                  <div v-if="widget.key === 'whatsapp'" class="dashboard-card-scroll">
                    <div class="dashboard-whatsapp-status">
                      <WhatsappGatewayDashboardCard />
                    </div>
                    <button
                      v-for="notification in whatsappNotificationsDisplayed"
                      :key="notification._id"
                      class="dashboard-notification-row whatsapp"
                      @click="abre_modal_view_notification(notification)"
                    >
                      <v-avatar size="42" color="#e8f5e9" class="dashboard-notification-avatar">
                        <img :src="getNotificationAvatar(notification)" alt="">
                      </v-avatar>
                      <div class="dashboard-notification-copy">
                        <strong>{{ getNotificationTitle(notification) }}</strong>
                        <span>{{ getNotificationSubtitle(notification) }}</span>
                      </div>
                      <small>{{ $moment(notification.created_at).fromNow() }}</small>
                    </button>
                    <div v-if="whatsappNotificationsDisplayed.length === 0" class="dashboard-empty-state">
                      <v-icon color="#25D366">mdi-whatsapp</v-icon>
                      <span>Nenhuma mensagem nova.</span>
                    </div>
                  </div>

                  <div v-if="widget.key === 'notifications'" class="dashboard-card-scroll">
                    <button
                      v-for="notification in commonNotificationsDisplayed"
                      :key="notification._id"
                      v-show="onlyUnreadeds ? !notification.readed : true"
                      class="dashboard-notification-row"
                      @click="abre_modal_view_notification(notification)"
                    >
                      <v-avatar
                        size="42"
                        :color="notification.type === 'internal_chat_message' ? '#182229' : (dark ? '#182229' : '#eef5f1')"
                        class="dashboard-notification-avatar"
                      >
                        <v-img
                          v-if="getNotificationAvatar(notification)"
                          :src="getNotificationAvatar(notification)"
                        ></v-img>
                        <v-icon v-else-if="notification.type === 'internal_chat_message'" color="#9be7bd" size="22">
                          mdi-account
                        </v-icon>
                        <v-icon v-else :color="$theme.primary" size="20">
                          {{ getTypeLinkByTypeNotification(notification).icon }}
                        </v-icon>
                      </v-avatar>
                      <div class="dashboard-notification-copy">
                        <strong>{{ getNotificationTitle(notification) }}</strong>
                        <span>{{ getNotificationSubtitle(notification) }}</span>
                      </div>
                      <small>{{ $moment(notification.created_at).fromNow() }}</small>
                    </button>
                    <div v-if="commonNotificationsDisplayed.length === 0" class="dashboard-empty-state">
                      <v-icon color="#f2f2f2">mdi-bell-outline</v-icon>
                      <span>Nada por aqui.</span>
                    </div>
                  </div>

                  <div v-if="widget.key === 'agenda'" class="dashboard-card-scroll">
                    <v-tabs v-model="tabCalendar" centered grow background-color="transparent">
                      <v-tab class="fonte-bold" v-if="get_permission_user['agenda']">Geral</v-tab>
                      <v-tab class="fonte-bold" v-if="get_permission_user['minha-agenda']">Para mim</v-tab>
                    </v-tabs>
                    <button
                      v-for="event in externalMovimentationsByTab"
                      :key="event._id"
                      class="dashboard-event-row"
                      @click="openEvent(event)"
                    >
                      <v-icon size="23" :color="getColor(event.status)">{{ getIcon(event.status) }}</v-icon>
                      <div>
                        <strong>{{ event.type | typeFilter }}</strong>
                        <span>{{ event.name }}</span>
                      </div>
                      <small>{{ event.visit_date }} {{ event.visit_hour }}</small>
                    </button>
                    <div v-if="externalMovimentationsByTab.length === 0" class="dashboard-empty-state">
                      <v-icon color="#f2b705">mdi-calendar-check-outline</v-icon>
                      <span>Nao ha agendamentos para hoje.</span>
                    </div>
                  </div>

                  <div v-if="widget.key === 'deliveries'" class="dashboard-card-scroll deliveries-widget deliveries-widget-map-only">
                    <div class="deliveries-map-board" :class="{ dark: dark }">
                      <div ref="dashboardDeliveryMap" class="deliveries-leaflet-map"></div>
                      <div class="deliveries-map-filters">
                        <v-select
                          dense
                          filled
                          rounded
                          hide-details
                          clearable
                          label="Entregador"
                          :dark="dark"
                          :items="dashboardDeliveryCouriers"
                          v-model="deliveryMapFilters.courier"
                        />
                        <v-text-field
                          dense
                          filled
                          rounded
                          hide-details
                          clearable
                          label="Cliente"
                          :dark="dark"
                          v-model="deliveryMapFilters.client"
                        />
                        <v-text-field
                          dense
                          filled
                          rounded
                          hide-details
                          clearable
                          label="Venda"
                          :dark="dark"
                          v-model="deliveryMapFilters.sale"
                        />
                      </div>
                      <div class="deliveries-map-legend">
                        <span v-for="status in dashboardDeliveryStatuses" :key="status.value">
                          <i :style="{ backgroundColor: status.color }"></i>{{ status.label }}
                        </span>
                      </div>
                      <div v-if="dashboardDeliveriesLoading || dashboardDeliveryMapLoading" class="deliveries-map-loading">
                        <v-progress-circular indeterminate color="primary" />
                        <span>Carregando mapa</span>
                      </div>
                    </div>
                  </div>

                  <div v-if="widget.key === 'ranking'" class="dashboard-card-scroll">
                    <div
                      v-for="(userRank, i) in rankingUsers"
                      :key="userRank.user._id"
                      class="dashboard-rank-row"
                    >
                      <v-avatar size="36" :color="dark ? '#182229' : '#e8efeb'">
                        <strong>{{ i + 1 }}</strong>
                      </v-avatar>
                      <div>
                        <strong>{{ userRank.user.nome }}</strong>
                        <span>{{ userRank.sales.length }} Propostas</span>
                      </div>
                      <v-avatar size="34" color="#f2f2f2">
                        <v-icon v-if="!userRank.user.profile_image" :color="$theme.primary">mdi-account-circle-outline</v-icon>
                        <v-img v-else :src="userRank.user.profile_image"></v-img>
                      </v-avatar>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </div>

          <div
            v-if="false"
            class="expande-horizontal wrap animate__animated animate__fadeIn animate__delay-1s"
          >
            <v-flex
              v-if="get_permission_user['contabilidade-de-caixas']"
              xs12
              class="pa-2"
              md3
            >
              <v-card
                style="border-radius: 12px;max-height: 40vh;"
                :color="dark ? '#444' : '#e5e5e5'"
                :dark="dark"
                v-if="chartValues"
                hover
                class="pa-2 pl-0 pt-0 expande-horizontal column animate__animated animate__fadeIn"
              >
                <h3 class="fonte-bold ma-2">
                  ðŸ’° EstatÃ­stica de Pagamento (30 dias)
                </h3>
                <Chart
                  :dark="dark"
                  type="doughnut"
                  ref="chartValue"
                  :backgroundColor="[
                    'rgb(255, 205, 86, 0.8)',
                    'rgb(255, 99, 132)',
                    'rgb(75, 192, 192)',
                    'rgb(201, 203, 207)'
                  ]"
                  description="Valor"
                  :labels="valuesPaid30Days.paymentTypes"
                  :dataChart="valuesPaid30Days.paymentValues"
                  :id="'chart-1'"
                  :height="200"
                />
              </v-card>
            </v-flex>
            <v-flex
              v-if="get_permission_user['gestor-de-pedidos']"
              xs12
              class="pa-2"
              md6
            >
              <v-card
                style="border-radius: 12px; max-height: 40vh;"
                :color="dark ? '#444' : '#e5e5e5'"
                :dark="dark"
                v-if="chartSales"
                hover
                class="pa-2 pl-0 pt-0 expande-horizontal column animate__animated animate__fadeIn"
              >
                <h3 class="fonte-bold ma-2">ðŸ“ˆ EstatÃ­stica Ãºltimos 30 dias</h3>
                <Chart
                  :dark="dark"
                  type="line"
                  ref="chartSales"
                  backgroundColor="rgb(255, 205, 86, 0.6)"
                  description="OrÃ§amentos"
                  :labels="salesLast30Days.days"
                  :dataChart="salesLast30Days.valuesForDays"
                  :id="'chart-2'"
                  :height="200"
                />
              </v-card>
            </v-flex>
            <v-flex
              v-if="get_permission_user['gestor-de-pedidos']"
              xs12
              md3
              class="pa-2"
            >
              <v-card
                style="max-height: 40vh;border-radius: 12px;"
                :color="dark ? '#444' : '#e5e5e5'"
                :dark="dark"
                hover
                class="pa-3 expande-horizontal wrap column windows-style-content"
              >
                <span class="fonte-bold" style="font-size: 14pt;"
                  >ðŸ“ {{ salesToday.length }} Hoje</span
                >
                <v-flex xs12>
                  <div
                    class="expande-horizontal centraliza"
                    style="max-height: 200px; min-height: 200px;"
                  >
                    <v-list
                      v-if="salesToday.length > 0"
                      dense
                      style="min-width: 100%; min-height: 200px; max-height: 200px; overflow: auto;"
                      :dark="dark"
                      :color="dark ? '#444' : '#e5e5e5'"
                      class="ma-0 pa-0 windows-style-content"
                    >
                      <v-list-item
                        @click="
                          $router.push(`/gestordepedidos/venda/${sale._id}`)
                        "
                        v-for="sale in salesToday"
                        :key="sale._id"
                        class="pa-0 ma-0 pr-2 animate__animated animate__fadeInUp"
                        style="border-radius: 6px; margin-bottom: 6px; max-height: 200px;"
                      >
                        <v-list-item-content>
                          <v-list-item-title class="fonte-bold">
                            {{ sale.compra.cliente.nome }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{
                              $helper.formataSaldo(sale.compra.preco_total || 0)
                            }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-chip
                            dark
                            x-small
                            class="fonte-bold"
                            :color="$theme.primary"
                          >
                            <span style="font-size: 14pt; margin-top: 6px;">{{
                              $moment(sale.created_at).format("HH:mm")
                            }}</span>
                          </v-chip>
                        </v-list-item-action>
                      </v-list-item>
                    </v-list>
                    <div
                      v-else
                      class="empty expande-horizontal centraliza column"
                    >
                      ðŸ“
                      <span class="fonte-bold">Nada por hoje ainda!</span>
                    </div>
                  </div>
                </v-flex>
              </v-card>
            </v-flex>
          </div>
        </div>
      </v-flex>
      <v-flex v-if="false" class="animate__animated animate__fadeIn animate__delay-1s" xs12>
        <div class="dashboard-widget-toolbar px-2 mt-1" :class="{ dark: dark }">
          <div>
            <h2 class="fonte-bold mb-0">Dashboard</h2>
            <span class="fonteMini grey--text">Organize os widgets do seu jeito.</span>
          </div>
          <v-spacer></v-spacer>
          <v-menu
            v-model="dashboardWidgetMenu"
            offset-y
            left
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                rounded
                depressed
                dark
                color="#075e54"
                class="fonte-bold"
                v-bind="attrs"
                v-on="on"
              >
                <v-icon left>mdi-view-grid-plus-outline</v-icon>
                Widgets
              </v-btn>
            </template>
            <v-card class="dashboard-widget-menu pa-2" :dark="dark" :color="dark ? '#182229' : '#fff'">
              <div class="fonte-bold px-2 py-1">Na dashboard</div>
              <v-list dense color="transparent" :dark="dark">
                <v-list-item
                  v-for="(widget, index) in activeDashboardWidgets"
                  :key="`active-${widget.key}`"
                >
                  <v-list-item-avatar size="32" :color="widget.color">
                    <v-icon dark small>{{ widget.icon }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ widget.title }}</v-list-item-title>
                  </v-list-item-content>
                  <v-btn icon small :disabled="index === 0" @click="moveDashboardWidget(index, -1)">
                    <v-icon small>mdi-arrow-up</v-icon>
                  </v-btn>
                  <v-btn icon small :disabled="index === activeDashboardWidgets.length - 1" @click="moveDashboardWidget(index, 1)">
                    <v-icon small>mdi-arrow-down</v-icon>
                  </v-btn>
                  <v-btn icon small :disabled="activeDashboardWidgets.length === 1" @click="removeDashboardWidget(widget.key)">
                    <v-icon small>mdi-close</v-icon>
                  </v-btn>
                </v-list-item>
              </v-list>
              <v-divider class="my-2"></v-divider>
              <div class="fonte-bold px-2 py-1">Adicionar widgets</div>
              <v-list dense color="transparent" :dark="dark">
                <v-list-item
                  v-for="widget in availableDashboardWidgets"
                  :key="widget.key"
                  @click="addDashboardWidget(widget.key)"
                >
                  <v-list-item-avatar size="32" :color="widget.color">
                    <v-icon dark small>{{ widget.icon }}</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title>{{ widget.title }}</v-list-item-title>
                    <v-list-item-subtitle>{{ widget.description }}</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-icon small>mdi-plus</v-icon>
                </v-list-item>
              </v-list>
              <div v-if="availableDashboardWidgets.length === 0" class="pa-3 text-center grey--text fonteMini">
                Todos os widgets ja estao na dashboard.
              </div>
            </v-card>
          </v-menu>
        </div>
        <div
          class="expande-horizontal centraliza animate__animated animate__fadeIn wrap"
        >
          <v-flex v-if="isDashboardWidgetActive('whatsapp')" xs12 md6 class="pa-2" :style="{ order: dashboardWidgetIndex('whatsapp') }">
            <v-card
              :color="dark ? '#111b21' : '#eefaf3'"
              :dark="dark"
              class="dashboard-modern-card pa-3 expande-horizontal wrap column"
            >
              <div class="dashboard-card-header">
                <div class="centraliza">
                  <v-avatar size="38" color="#25D366" class="mr-2">
                    <v-icon dark>mdi-whatsapp</v-icon>
                  </v-avatar>
                  <div>
                    <h3 class="fonte-bold mb-0">Mensagens WhatsApp</h3>
                    <span class="fonteMini grey--text">Atendimentos recebidos em tempo real.</span>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-btn icon small :disabled="dashboardWidgetIndex('whatsapp') === 0" @click="moveDashboardWidget(dashboardWidgetIndex('whatsapp'), -1)">
                  <v-icon small>mdi-arrow-left</v-icon>
                </v-btn>
                <v-btn icon small :disabled="dashboardWidgetIndex('whatsapp') === activeDashboardWidgets.length - 1" @click="moveDashboardWidget(dashboardWidgetIndex('whatsapp'), 1)">
                  <v-icon small>mdi-arrow-right</v-icon>
                </v-btn>
                <v-btn icon small @click="removeDashboardWidget('whatsapp')">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </div>
              <div class="dashboard-whatsapp-status">
                <WhatsappGatewayDashboardCard />
              </div>
              <div class="dashboard-card-scroll">
                <button
                  v-for="notification in whatsappNotificationsDisplayed"
                  :key="notification._id"
                  class="dashboard-notification-row whatsapp"
                  @click="abre_modal_view_notification(notification)"
                >
                  <v-icon color="#25D366" size="18">mdi-whatsapp</v-icon>
                  <span>{{ getFriendlyNotificationDescription(notification) }}</span>
                  <small>{{ $moment(notification.created_at).fromNow() }}</small>
                </button>
                <div v-if="whatsappNotificationsDisplayed.length === 0" class="dashboard-empty-state">
                  <v-icon color="#25D366">mdi-whatsapp</v-icon>
                  <span>Nenhuma mensagem nova.</span>
                </div>
              </div>
            </v-card>
          </v-flex>
          <v-flex v-if="isDashboardWidgetActive('notifications')" xs12 md6 class="pa-2" :style="{ order: dashboardWidgetIndex('notifications') }">
            <v-card
              :color="dark ? '#444' : '#e5e5e5'"
              :dark="dark"
              style="border-radius: 12px;"
              class="pa-3 expande-horizontal wrap column"
            >
              <div class="expande-horizontal centraliza">
                <span class="fonte-bold" style="font-size: 16pt;"
                  >Últimas atualizações</span
                >
                <v-spacer></v-spacer>
                <v-switch
                  small
                  hide-details
                  class="fonte fonteMini pa-0 ma-0"
                  :color="$theme.primary"
                  v-model="onlyUnreadeds"
                >
                </v-switch>
                <span
                  style="cursor: pointer;"
                  @click="onlyUnreadeds = !onlyUnreadeds"
                  class="fonteMini fonte grey--text"
                >
                  nÃ£o lidas
                </span>
              </div>
              <div
                v-if="false && whatsappNotificationsDisplayed.length"
                class="dashboard-whatsapp-updates"
                :class="{ 'dashboard-whatsapp-updates-dark': dark }"
              >
                <div class="dashboard-whatsapp-header">
                  <WhatsappGatewayDashboardCard />
                  <span class="fonte-bold">Mensagens WhatsApp</span>
                </div>
                <button
                  v-for="notification in whatsappNotificationsDisplayed"
                  :key="notification._id"
                  class="dashboard-whatsapp-item"
                  @click="abre_modal_view_notification(notification)"
                >
                  <v-icon color="#25D366" size="18">mdi-whatsapp</v-icon>
                  <span>{{ getFriendlyNotificationDescription(notification) }}</span>
                  <small>{{ $moment(notification.created_at).fromNow() }}</small>
                </button>
              </div>
              <v-flex xs12>
                <div
                  class="expande-horizontal"
                  style="max-height: 44vh; min-height: 44vh; overflow: auto;"
                >
                  <v-flex xs12>
                    <v-list
                      class="fonte windows-style-content"
                      v-if="commonNotificationsDisplayed.length > 0"
                      width="100%"
                      :dark="dark"
                      :color="dark ? '#444' : '#e5e5e5'"
                      style="max-height: 40vh; overflow: auto;"
                    >
                      <template
                        v-for="(notification, i) in commonNotificationsDisplayed"
                      >
                        <v-list-item
                          class="item-list-notification mr-2 animate__animated animate__fadeInUp"
                          style="border: none; border-radius: 0px;"
                          :key="notification._id"
                          v-if="onlyUnreadeds ? !notification.readed : true"
                          @click="abre_modal_view_notification(notification)"
                        >
                          <!-- <v-avatar size="31" class="mr-3" color="#f2f2f2">
                            <v-icon :color="$theme.primary" size="21">
                              {{ getTypeLinkByTypeNotification(notification).icon }}
                            </v-icon>
                          </v-avatar> -->
                          <v-list-item-content>
                            <v-list-item-title>
                              <span
                                :class="{
                                  'unreaded-notification font-weight-bold': !notification.readed
                                }"
                              >
                                {{
                                  getTypeLinkByTypeNotification(notification)
                                    .title
                                }}
                              </span>
                            </v-list-item-title>
                            <span
                              class="fonte grey--text mt-1"
                              :class="{
                                'unreaded-notification': !notification.readed
                              }"
                            >
                              {{ getFriendlyNotificationDescription(notification) }}
                            </span>
                            <div class="expande-horizontal">
                              <span
                                class="fonte mt-1"
                                :style="
                                  `color: ${
                                    notification.readed
                                      ? 'grey'
                                      : $theme.secondary
                                  }`
                                "
                                :class="{
                                  'unreaded-notification': !notification.readed
                                }"
                                style="font-size: 12pt;"
                              >
                                {{
                                  $moment(notification.created_at).fromNow()
                                }}</span
                              >
                              <span
                                class="fonte mt-1"
                                :style="
                                  `color: ${
                                    notification.readed
                                      ? 'grey'
                                      : $theme.secondary
                                  }`
                                "
                                v-if="notification.readed"
                                :class="{
                                  'unreaded-notification': !notification.readed
                                }"
                                style="font-size: 12pt;"
                              >
                                , foi lida
                                {{
                                  $moment(notification.readDate).format(
                                    "DD/MM/YY [Ã s] HH:mm"
                                  )
                                }}
                              </span>
                              <span
                                class="fonte fonteMini mt-1"
                                :style="`color: ${$theme.secondary}`"
                                v-else
                                :class="{
                                  'unreaded-notification': !notification.readed
                                }"
                                style="font-size: 12pt;"
                              >
                                , nÃ£o lida ainda.
                              </span>
                              <v-icon
                                class="ml-2"
                                :class="{
                                  'unreaded-notification': !notification.readed
                                }"
                                color="orange"
                                size="15"
                                v-if="!notification.readed"
                                >mdi-check</v-icon
                              >
                              <v-icon
                                class="ml-2"
                                :class="{
                                  'unreaded-notification': !notification.readed
                                }"
                                color="green"
                                size="15"
                                v-if="notification.readed"
                                >mdi-check-all</v-icon
                              >
                            </div>
                          </v-list-item-content>
                          <!-- <v-list-item-action>
                                
                              </v-list-item-action> -->
                        </v-list-item>
                        <!-- <v-divider :key="`divider-${i}`"></v-divider> -->
                      </template>
                    </v-list>
                    <div
                      v-if="commonNotificationsDisplayed.length === 0"
                      style="border: 1px solid #cbc7c7; min-height: 40vh;border-radius: 6px;"
                      class="fonte mt-2 expande-horizontal centraliza column"
                    >
                      <v-avatar class="mb-3" :color="$theme.primary">
                        <v-icon color="#f2f2f2">mdi-bell-outline</v-icon>
                      </v-avatar>
                      <span :style="`color: ${$theme.primary}`" class="fonte"
                        >Nada por aqui</span
                      >
                      <span class="text-center grey--text fonteMini fonte">
                        Novas notificaÃ§Ãµes aparecerÃ£o aqui
                      </span>
                    </div>
                  </v-flex>
                </div>
              </v-flex>
            </v-card>
          </v-flex>
          <v-flex v-if="false" xs12 md3 class="pa-2">
            <v-card
              class="pa-3"
              :color="dark ? '#444' : '#e5e5e5'"
              :dark="dark"
              style="border-radius: 12px; min-height: 50vh; max-height: 50vh; overflow: hidden;"
            >
              <h3 class="fonte-bold mr-3">
                ðŸ“‘ Fluxo de contas
              </h3>
              <v-list
                class="fonte windows-style-content"
                style="max-height: 43vh; overflow: auto;"
                color="transparent"
                :dark="dark"
              >
                <v-list-item
                  class="px-0"
                  v-for="(userRank, i) in rankingUsers"
                  :key="userRank.user._id"
                >
                  <v-avatar
                    size="35"
                    class="mr-2"
                    :color="dark ? '#444' : '#e5e5e5'"
                  >
                    <h3>{{ i + 1 }}Âº</h3>
                  </v-avatar>
                  <!-- <h3 class="fonte-bold mr-3">{{ userRank.sales.length }}</h3> -->
                  <v-list-item-content>
                    <v-list-item-title>{{
                      userRank.user.nome
                    }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ userRank.sales.length }} Propostas
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
          <v-flex v-if="isDashboardWidgetActive('agenda')" xs12 class="pa-2" md3 :style="{ order: dashboardWidgetIndex('agenda') }">
            <v-card
              class="pa-3"
              :color="dark ? '#444' : '#e5e5e5'"
              :dark="dark"
              style="border-radius: 12px; min-height: 50vh; max-height: 50vh; overflow: auto;"
            >
              <h3 class="fonte-bold">ðŸ“Œ Agenda de Hoje</h3>
              <v-tabs
                v-model="tabCalendar"
                centered
                grow
                background-color="transparent"
              >
                <v-tab class="fonte-bold" v-if="get_permission_user['agenda']"
                  >Geral</v-tab
                >
                <v-tab
                  class="fonte-bold"
                  v-if="get_permission_user['minha-agenda']"
                  >Para mim</v-tab
                >
              </v-tabs>
              <v-list
                class="px-0 ma-0 fonte windows-style-content pr-2"
                color="transparent"
                v-if="externalMovimentationsByTab.length"
                style="max-height: 30vh; overflow: auto;"
              >
                <v-list-item
                  @click="openEvent(event)"
                  v-for="event in externalMovimentationsByTab"
                  :key="event._id"
                  class="px-2 mx-0 list-events-item-selected"
                >
                  <v-icon
                    class="mr-3"
                    size="23"
                    :color="getColor(event.status)"
                    >{{ getIcon(event.status) }}</v-icon
                  >

                  <v-list-item-content>
                    <v-list-item-title>
                      <span
                        style="font-size: 14pt;"
                        class="fonte-bold"
                        :class="{
                          'white--text': dark,
                          'black--text': !dark
                        }"
                        >{{ event.type | typeFilter }}</span
                      >
                      <span style="font-size: 10pt;" class="grey--text ml-2"
                        >{{ event.visit_date }} {{ event.visit_hour }}</span
                      >
                    </v-list-item-title>
                    <v-list-item-subtitle class="grey--text">
                      {{ event.name }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-btn
                      text
                      dark
                      :color="getColor(event.status)"
                      x-small
                      depressed
                      rounded
                    >
                      <span class="fonte-bold" style="padding-top: 2px;">{{
                        getStatus(event.status)
                      }}</span>
                      <!-- <v-icon size="15">
                        {{ getIcon(event.status) }}
                      </v-icon> -->
                    </v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <div
                v-else
                class="expande-horizontal centraliza column"
                style="height: 260px; border-radius: 12px; margin-top: 6px;"
              >
                ðŸ“Œ
                <span
                  :class="{
                    'white--text': dark,
                    'grey--text': !dark
                  }"
                  class="fonte-bold mt-2"
                  >NÃ£o hÃ¡ agendamentos para hoje!</span
                >
              </div>
            </v-card>
          </v-flex>
          <v-flex v-if="isDashboardWidgetActive('ranking')" xs12 md3 class="pa-2" :style="{ order: dashboardWidgetIndex('ranking') }">
            <v-card
              class="pa-3"
              :color="dark ? '#444' : '#e5e5e5'"
              :dark="dark"
              style="border-radius: 12px; min-height: 50vh; max-height: 50vh; overflow: hidden;"
            >
              <h3 class="fonte-bold mr-3">
                ðŸ… Ranking
              </h3>
              <v-list
                class="fonte windows-style-content"
                style="max-height: 43vh; overflow: auto;"
                color="transparent"
                :dark="dark"
              >
                <v-list-item
                  class="px-0 pr-2"
                  v-for="(userRank, i) in rankingUsers"
                  :key="userRank.user._id"
                >
                  <v-avatar
                    size="35"
                    class="mr-2"
                    :color="dark ? '#444' : '#e5e5e5'"
                  >
                    <h3>{{ i + 1 }}Âº</h3>
                  </v-avatar>
                  <!-- <h3 class="fonte-bold mr-3">{{ userRank.sales.length }}</h3> -->
                  <v-list-item-content>
                    <v-list-item-title>{{
                      userRank.user.nome
                    }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{ userRank.sales.length }} Propostas
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    <v-avatar size="36" color="#f2f2f2">
                      <v-icon
                        v-if="!userRank.user.profile_image"
                        :color="$theme.primary"
                        >mdi-account-circle-outline</v-icon
                      >
                      <v-img v-else :src="userRank.user.profile_image"></v-img>
                    </v-avatar>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
            </v-card>
          </v-flex>
        </div>
      </v-flex>
    </div>
  </layout>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { EventBus } from "@/main.js";
import { driver } from "driver.js";
import { GridStack } from "gridstack";
import "gridstack/dist/h5/gridstack-dd-native";
import "gridstack/dist/gridstack.min.css";
import { getMessaging, getToken, onMessage } from "firebase/messaging";
import WhatsappGatewayDashboardCard from "@/apps/WhatsappAtendimento/components/DashboardCard.vue";
import Chart from "@/apps/27#Caixas/components/Chart.vue";
import axios from "axios";
import { service as externalMovimentationService } from "@/apps/ExternalMovimentation/meta";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

export default {
  components: {
    WhatsappGatewayDashboardCard,
    Chart
  },
  data() {
    return {
      pingTime: 0,
      timeInit: 0,
      tabCalendar: 0,
      deliveryTab: 0,
      showWelcome: true,
      chartValues: true,
      chartSales: true,
      dark: false,
      dateFilter: "",
      deliveryRangeStart: "",
      deliveryRangeEnd: "",
      deliveryStartMenu: false,
      deliveryEndMenu: false,
      deliveryMapFilters: {
        courier: "",
        client: "",
        sale: ""
      },
      dashboardDeliveries: {
        last7: { docs: [], summary: {} },
        today: { docs: [], summary: {} },
        yesterday: { docs: [], summary: {} },
        range: { docs: [], summary: {} }
      },
      dashboardDeliveryMetrics: {
        total_deliveries: 0,
        average_hours: 0,
        average_days: 0,
        fastest: null,
        slowest: null,
        items: []
      },
      dashboardDeliveriesLoading: false,
      dashboardDeliveryMapLoading: false,
      dashboardDeliveryMap: null,
      dashboardDeliveryMarkers: [],
      dashboardDeliveryRouteLayers: [],
      dashboardDeliveryMapRenderTimer: null,
      dashboardOperationalMapCenter: null,
      dashboardBrowserMapCenter: null,
      dashboardPaymentConfig: {
        money: { active: true, tax_porcentage: 0 },
        custom_methods: []
      },
      notifications: [],
      onlyUnreadeds: false,
      dashboardWidgetMenu: false,
      dashboardWidgetMenuPosition: { x: 0, y: 0 },
      dashboardGrid: null,
      dashboardWidgetFeedback: "",
      dashboardEditMode: false,
      dashboardWidgets: ["shortcuts", "whatsapp", "notifications"],
      dashboardLayouts: {},
      rotas: [
        {
          name: "Início",
          path: "/dashboard"
        }
      ],
      driver: null,
      dashboardRealtimeHandler: null,
      options: [],

      menus: [
        {
          icon: "mdi-view-dashboard-outline",
          name: "Dashboard",
          route: "/dashboard",
          permission: () => this.get_permission_user["dashboard"]
        },
        {
          icon: "mdi-cash-register",
          name: "Caixa",
          route: "/atendimento",
          permission: () => this.get_permission_user["vender"]
        },
        {
          icon: "mdi-arrow-decision",
          name: "Gestor de Vendas",
          route: "/gestordepedidos",
          permission: () => this.get_permission_user["gestor-de-vendas"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-calendar-badge-outline",
          name: "Minha Agenda",
          route: "/minha-agenda",
          permission: () =>
            this.get_permission_user["minha-agenda"]
        },
        {
          icon: "mdi-calendar-edit-outline",
          name: "Agenda",
          route: "/agenda",
          permission: () =>
            this.get_permission_user["agenda"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-clipboard-list-outline",
          name: "Lista de compras",
          route: "/lista-de-compras",
          permission: () =>
            this.get_permission_user["lista-de-compras"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-library-outline",
          name: "Produtos",
          route: "/insumos",
          permission: () => this.get_permission_user["produtos"]
        },
        {
          icon: "mdi-account-circle-outline",
          name: "Clientes",
          route: "/clientes",
          permission: () => this.get_permission_user["clientes"]
        },
        {
          icon: "mdi-account-group-outline",
          name: "Colaboradores",
          route: "/funcionarios",
          permission: () => this.get_permission_user["colaboradores"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-ballot-outline",
          name: "Contas",
          route: "/invoices",
          permission: () =>
            this.get_permission_user["contas"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-receipt-text-check-outline",
          name: "Contabilidade",
          route: "/acompanhamento-de-caixa",
          permission: () =>
            this.get_permission_user["contabilidade-de-caixas"]
        },
        {
          icon: "mdi-receipt-text-check-outline",
          name: "RelatÃ³rio",
          route: "/caixas",
          permission: () =>
            this.get_permission_user["relatorio"]
        },
        {
          name: "divider",
          permission: () => false
        },
        {
          icon: "mdi-lock-outline",
          name: "PermissÃµes",
          route: "/permissoes",
          permission: () => this.get_permission_user["permissoes"]
        },
        {
          icon: "mdi-whatsapp",
          name: "WhatsApp",
          route: "/whatsapp-atendimento",
          permission: () =>
            this.getLoggedUser.admin ||
            this.get_permission_user["whatsapp-atendimento"] ||
            String((this.getLoggedUser.permissao && this.getLoggedUser.permissao.nome) || "")
              .toLowerCase()
              .includes("adm")
        }
        // {
        //   icon: "mdi-cog-outline",
        //   name: "ConfiguraÃ§Ãµes",
        //   route: "/configurar-loja",
        //   permission: () => this.get_permission_user["configuracoes"] && this.get_permission_plan?.includes("configuracoes")
        // }
      ]
    };
  },
  computed: {
    ...mapGetters([
      "get_dashboard",
      "getLoggedUser",
      "get_permission_user",
      "get_permission_plan",
      "get_gestordepedidos",
      "get_funcionarios",
      "get_external_movimentations"
    ]),
    dashboardCompanyLogo() {
      const tenant = this.getLoggedUser?.activeTenant || this.getLoggedUser?.tenant?.[0] || {};
      return tenant.profileImage || tenant.logo || "img/logo_mini.png";
    },
    externalMovimentationsByTab() {
      let today = this.$moment().format("DD/MM/YYYY");
      let externalMovimentations = this.normalizeExternalMovimentations(this.get_external_movimentations);
      let movimentations = [];

      // nÃ£o tem permissÃ£o pra ver a agenda geral, carrega apenas a do usuÃ¡rio
      if (this.tabCalendar == 0 && !this.get_permission_user["agenda"]) {
        movimentations = externalMovimentations.filter(
          e => e.visit_date == today && this.sameUser(e.executor, this.getLoggedUser)
        );
      }

      //tab 1 sempre Ã© a agenda pessoal
      if (this.tabCalendar == 1) {
        movimentations = externalMovimentations.filter(
          e => e.visit_date == today && this.sameUser(e.executor, this.getLoggedUser)
        );
      }

      //tem permissÃ£o, entÃ£o carrega na tab 0 a agenda geral de hoje
      if (this.tabCalendar == 0 && this.get_permission_user["agenda"]) {
        movimentations = externalMovimentations.filter(
          e => e.visit_date == today
        );
      }
      return movimentations;
    },
    activeDashboardDeliveryPeriod() {
      return "last7";
    },
    dashboardDeliveryStatuses() {
      return [
        { value: "waiting", label: "Agendada", color: "#fb8c00", icon: "mdi-clock-outline" },
        { value: "on_the_way", label: "Em rota", color: "#2eaf5d", icon: "mdi-truck-fast-outline" },
        { value: "done", label: "Concluída", color: "#1e88e5", icon: "mdi-check-circle-outline" },
        { value: "canceled", label: "Cancelada", color: "#e53935", icon: "mdi-cancel" }
      ];
    },
    dashboardDeliveryMapSource() {
      return this.dashboardDeliveryItems(this.activeDashboardDeliveryPeriod);
    },
    dashboardDeliveryCouriers() {
      const names = this.dashboardDeliveryMapSource
        .map(delivery => this.dashboardUserName(delivery.executor))
        .filter(name => name && name !== "Não informado");
      return [...new Set(names)].sort((a, b) => a.localeCompare(b));
    },
    dashboardDeliveryMapItems() {
      const client = String(this.deliveryMapFilters.client || "").toLowerCase();
      const sale = String(this.deliveryMapFilters.sale || "").toLowerCase();
      const courier = String(this.deliveryMapFilters.courier || "").toLowerCase();
      return this.dashboardDeliveryMapSource.filter(delivery => {
        const deliveryClient = this.dashboardClientName(delivery).toLowerCase();
        const deliverySale = String(this.dashboardSaleNumber(delivery)).toLowerCase();
        const deliveryCourier = this.dashboardUserName(delivery.executor).toLowerCase();
        return (!client || deliveryClient.includes(client)) &&
          (!sale || deliverySale.includes(sale)) &&
          (!courier || deliveryCourier === courier);
      });
    },
    dashboardDeliveryMapPoints() {
      const points = [];
      this.dashboardDeliveryMapItems.forEach(delivery => {
        const deliveryCoords = this.dashboardDeliveryCoordinates(delivery);
        if (deliveryCoords) points.push({ type: "delivery", delivery, coords: deliveryCoords });
        const driverCoords = this.dashboardDriverCoordinates(delivery);
        if (driverCoords) points.push({ type: "driver", delivery, coords: driverCoords });
      });
      return points;
    },
    dashboardDeliveryMapSignature() {
      return this.dashboardDeliveryMapItems.map(delivery => [
        delivery._id,
        delivery.status,
        this.dashboardClientName(delivery),
        this.dashboardSaleNumber(delivery),
        this.dashboardUserName(delivery.executor),
        JSON.stringify(this.dashboardDeliveryCoordinates(delivery) || {}),
        JSON.stringify(this.dashboardDriverCoordinates(delivery) || {}),
        JSON.stringify(delivery.route_summary || {}),
        this.dashboardDeliveryLogs(delivery).map(log => `${log.type}:${log.date}:${log.description}`).join(",")
      ].join("|")).join(";");
    },
    notificationsUnreadeds() {
      return this.notifications.filter(n => !n.readed);
    },
    displayedNotifications() {
      return this.onlyUnreadeds ? this.notificationsUnreadeds : this.notifications;
    },
    whatsappNotificationsDisplayed() {
      return this.displayedNotifications.filter(
        notification => notification.type === "whatsapp_message_received"
      );
    },
    commonNotificationsDisplayed() {
      return this.displayedNotifications.filter(
        notification => notification.type !== "whatsapp_message_received"
      );
    },
    dashboardWidgetCatalog() {
      return [
        {
          key: "shortcuts",
          title: "Atalhos",
          description: "Menus principais do StonePro",
          icon: "mdi-apps",
          color: "#075e54",
          w: 4,
          h: 3,
          permission: () => this.permittedMenus.length > 0
        },
        {
          key: "whatsapp",
          title: "Mensagens WhatsApp",
          description: "Atendimentos em tempo real",
          icon: "mdi-whatsapp",
          color: "#25D366",
          w: 4,
          h: 4
        },
        {
          key: "notifications",
          title: "Últimas atualizações",
          description: "Eventos e alertas do sistema",
          icon: "mdi-bell-ring-outline",
          color: this.$theme.primary,
          w: 4,
          h: 4
        },
        {
          key: "salesChart",
          title: "Orçamentos",
          description: "Ultimos 30 dias",
          icon: "mdi-chart-line",
          color: "#ffb300",
          w: 5,
          h: 4,
          permission: () => this.get_permission_user["gestor-de-pedidos"]
        },
        {
          key: "paymentChart",
          title: "Pagamentos",
          description: "Recebimentos dos ultimos 30 dias",
          icon: "mdi-cash-multiple",
          color: "#00a884",
          w: 4,
          h: 4,
          permission: () => this.get_permission_user["contabilidade-de-caixas"]
        },
        {
          key: "todaySales",
          title: `${this.salesToday.length} Hoje`,
          description: "Vendas criadas hoje",
          icon: "mdi-file-document-edit-outline",
          color: "#075e54",
          w: 3,
          h: 4,
          permission: () => this.get_permission_user["gestor-de-pedidos"]
        },
        {
          key: "agenda",
          title: "Agenda de Hoje",
          description: "Compromissos do dia",
          icon: "mdi-calendar-check-outline",
          color: "#f2b705",
          w: 3,
          h: 4,
          permission: () => this.get_permission_user["agenda"] || this.get_permission_user["minha-agenda"]
        },
        {
          key: "deliveries",
          title: "Entregas",
          description: "Entregas agendadas e tempo mÃ©dio",
          icon: "mdi-truck-delivery-outline",
          color: "#f2b705",
          w: 4,
          h: 4,
          permission: () => this.get_permission_user["ver-entregas"]
        },
        {
          key: "ranking",
          title: "Ranking",
          description: "Propostas por funcionario",
          icon: "mdi-podium",
          color: "#7c4dff",
          w: 3,
          h: 4
        }
      ];
    },
    activeDashboardWidgets() {
      return this.dashboardWidgets
        .map(key => this.dashboardWidgetCatalog.find(widget => widget.key === key))
        .filter(widget => widget && (!widget.permission || widget.permission()));
    },
    availableDashboardWidgets() {
      return this.dashboardWidgetCatalog.filter(
        widget => !this.dashboardWidgets.includes(widget.key) && (!widget.permission || widget.permission())
      );
    },
    permittedMenus() {
      return this.menus.filter(menu => menu.route && menu.permission && menu.permission());
    },
    salesToday() {
      let today = this.$moment().format("YYYY-MM-DD");
      let sales = this.get_gestordepedidos.docs;
      let salesToday = sales.filter(
        sale => this.$moment(sale.created_at).format("YYYY-MM-DD") === today
      );
      return salesToday;
      // return sales;
    },
    salesLast30Days() {
      let sales = this.get_gestordepedidos.docs;
      // let limit = this.$moment().subtract(30, "days").format("YYYY-MM-DD");
      // let salesLast30Days = sales.filter(sale => {
      //   return this.$moment(sale.created_at).format("YYYY-MM-DD") >= limit;
      // })
      let days = [];
      let valuesForDays = [];
      for (let i = 30; i > 0; i--) {
        let day = this.$moment()
          .subtract(i, "days")
          .format("DD/MM");
        let salesForDay = sales.filter(
          sale => this.$moment(sale.created_at).format("DD/MM") === day
        );

        days.push(day);
        valuesForDays.push(salesForDay.length);
      }
      return {
        days,
        valuesForDays
      };
    },
    dashboardPaymentMethods() {
      const config = this.dashboardPaymentConfig || {};
      const configuredMethods = [
        {
          key: "dinheiro",
          label: "Dinheiro",
          tax_porcentage: Number(config.money && config.money.tax_porcentage || 0)
        },
        ...(Array.isArray(config.custom_methods) ? config.custom_methods : [])
          .filter(method => method && method.name)
          .map((method, index) => ({
            key: String(method.id || `custom_${index + 1}`),
            label: method.name,
            tax_porcentage: Number(method.tax_porcentage || 0),
            active: method.active !== false
          }))
      ];
      return configuredMethods.filter((method, index, methods) =>
        methods.findIndex(item => this.normalizePaymentMethodValue(item.key) === this.normalizePaymentMethodValue(method.key)) === index
      );
    },
    dashboardPaymentChartColors() {
      const colors = [
        "rgba(22, 163, 74, .82)",
        "rgba(14, 165, 233, .82)",
        "rgba(245, 158, 11, .82)",
        "rgba(168, 85, 247, .82)",
        "rgba(236, 72, 153, .82)",
        "rgba(20, 184, 166, .82)",
        "rgba(239, 68, 68, .82)"
      ];
      return this.dashboardPaymentMethods.map((method, index) => colors[index % colors.length]);
    },
    valuesPaid30Days() {
      let sales = this.get_gestordepedidos && Array.isArray(this.get_gestordepedidos.docs)
        ? this.get_gestordepedidos.docs
        : [];
      let limit = this.$moment()
        .subtract(30, "days")
        .format("YYYY-MM-DD");
      const paymentMethods = this.dashboardPaymentMethods;
      const paymentValues = paymentMethods.map(() => 0);
      sales.forEach(sale => {
        let salePayments = Array.isArray(sale.historico_de_pagamento)
          ? sale.historico_de_pagamento
          : [];
        salePayments.forEach(payment => {
          const paymentDate = payment.data
            ? this.$moment(payment.data).format("YYYY-MM-DD")
            : this.$moment(sale.created_at).format("YYYY-MM-DD");
          if (paymentDate < limit) return;
          const paymentName = this.normalizePaymentMethodValue(payment.forma_de_pagamento);
          const methodIndex = paymentMethods.findIndex(method =>
            this.normalizePaymentMethodValue(method.key) === paymentName ||
            this.normalizePaymentMethodValue(method.label) === paymentName
          );
          if (methodIndex >= 0) paymentValues[methodIndex] += Number(payment.valor || 0);
        });
      });

      return {
        paymentTypes: paymentMethods.map(method => method.label),
        paymentValues,
        paymentBreakdown: paymentMethods.map((method, index) => ({
          ...method,
          value: paymentValues[index]
        }))
      };
    },
    rankingUsers() {
      let users = this.get_funcionarios.docs;
      if (!users) return [];
      let userWithSales = users.map(user => {
        let sales = this.get_gestordepedidos.docs.filter(
          sale =>
            sale.caixa.funcionario && sale.caixa.funcionario._id == user._id
        );
        return {
          user,
          sales
        };
      });
      let sortedUsers = userWithSales.sort(
        (a, b) => b.sales.length - a.sales.length
      );
      return sortedUsers;
    }
  },
  filters: {
    typeFilter(value) {
      const types = [
        {
          name: "Visita",
          value: "visit"
        },
        {
          name: "Data limite",
          value: "limit_date"
        },
        {
          name: "Entrega",
          value: "delivery"
        },
        {
          name: "LigaÃ§Ã£o",
          value: "ligaÃ§Ã£o"
        },
        {
          name: "E-mail",
          value: "email"
        },
        {
          name: "Whatsapp",
          value: "whatsapp"
        },
        {
          name: "Outros",
          value: "other"
        }
      ];
      let res = types.filter(i => i.value == value)[0].name || "";
      return res;
    }
  },
  methods: {
    ...mapActions([
      "listar_gestordepedidos",
      "listar_funcionarios",
      "listar_external_movimentations",
      "listar_my_external_movimentations"
    ]),
    normalizePaymentMethodValue(value) {
      return String(value || "")
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "")
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9]+/g, "_")
        .replace(/^_+|_+$/g, "");
    },
    normalizeDashboardPaymentConfig(config = {}) {
      return {
        money: { active: true, tax_porcentage: 0, ...(config.money || {}) },
        custom_methods: Array.isArray(config.custom_methods)
          ? config.custom_methods
              .filter(method => method && method.name)
              .map((method, index) => ({
                id: method.id || `custom_${index + 1}`,
                name: method.name,
                type: method.type || "custom",
                active: method.active !== false,
                tax_porcentage: Number(method.tax_porcentage || 0)
              }))
          : []
      };
    },
    loadDashboardPaymentConfig() {
      const tenant = this.getLoggedUser && (this.getLoggedUser.activeTenant || this.getLoggedUser.tenant?.[0]);
      if (tenant && tenant.payment_sys_config) {
        this.dashboardPaymentConfig = this.normalizeDashboardPaymentConfig(tenant.payment_sys_config);
      }
      this.$run("marketplaces/get-config-payment-sys")
        .then(res => {
          this.dashboardPaymentConfig = this.normalizeDashboardPaymentConfig(
            res.data && res.data.payment_sys_config
          );
        })
        .catch(() => {});
    },
    normalizeExternalMovimentations(value) {
      if (Array.isArray(value)) return value;
      if (value && Array.isArray(value.docs)) return value.docs;
      if (value && Array.isArray(value.data)) return value.data;
      return [];
    },
    normalizeId(value) {
      if (!value) return "";
      if (typeof value === "string") return value;
      if (value._id) return String(value._id);
      if (value.id) return String(value.id);
      return "";
    },
    sameUser(a, b) {
      const aId = this.normalizeId(a);
      const bId = this.normalizeId(b);
      return Boolean(aId && bId && aId === bId);
    },
    testPing() {
      return;
      this.timeInit = Date.now();
      let timeEnd;
      const self = this;
      axios
        .get("https://8.8.4.4")
        .then(() => {
          timeEnd = Date.now();
          self.pingTime = timeEnd - self.timeInit;
          setTimeout(() => {
            // self.testPing();
          }, 1000);
        })
        .catch(() => {
          timeEnd = Date.now();
          self.pingTime = timeEnd - self.timeInit;
          setTimeout(() => {
            // self.testPing();
          }, 1000);
        });
    },
    openDashboardWidgetMenu(event) {
      const rect = event && event.currentTarget
        ? event.currentTarget.getBoundingClientRect()
        : { left: window.innerWidth - 320, bottom: 72 };
      this.dashboardWidgetMenuPosition = {
        x: Math.round(rect.left),
        y: Math.round(rect.bottom + 8)
      };
      this.dashboardWidgetMenu = true;
    },
    loadDashboardWidgets() {
      try {
        const savedWidgets = JSON.parse(localStorage.getItem("stonepro.dashboard.widgets") || "[]");
        const savedLayouts = JSON.parse(localStorage.getItem("stonepro.dashboard.layouts") || "{}");
        const validKeys = this.dashboardWidgetCatalog.map(widget => widget.key);
        const widgets = savedWidgets.filter(key => validKeys.includes(key));
        if (widgets.length) this.dashboardWidgets = widgets;
        this.dashboardLayouts = this.normalizeDashboardLayouts(savedLayouts || {});
        localStorage.removeItem("stonepro.dashboard.editMode");
      } catch (error) {
        this.dashboardWidgets = ["shortcuts", "whatsapp", "notifications"];
        this.dashboardLayouts = {};
      }
    },
    saveDashboardWidgets() {
      localStorage.setItem("stonepro.dashboard.widgets", JSON.stringify(this.dashboardWidgets));
      localStorage.setItem("stonepro.dashboard.layouts", JSON.stringify(this.dashboardLayouts));
    },
    dashboardWidgetLayout(key) {
      const widget = this.dashboardWidgetCatalog.find(item => item.key === key) || {};
      const index = this.dashboardWidgets.indexOf(key);
      const defaultWidth = widget.w || 4;
      const savedLayout = this.dashboardLayouts[key] || {};
      return {
        x: Math.min(11, Math.max(0, savedLayout.x ?? ((index * defaultWidth) % 12))),
        y: Math.floor((index * defaultWidth) / 12) * 4,
        w: defaultWidth,
        h: widget.h || 4,
        ...savedLayout,
        w: Math.min(12, Math.max(widget.minW || 3, savedLayout.w || defaultWidth)),
        h: Math.max(widget.minH || 2, savedLayout.h || widget.h || 4)
      };
    },
    normalizeDashboardLayouts(layouts = {}) {
      const normalized = {};
      this.dashboardWidgets.forEach(key => {
        const widget = this.dashboardWidgetCatalog.find(item => item.key === key) || {};
        const layout = layouts[key] || {};
        const fallback = this.defaultDashboardWidgetLayout(key);
        const minW = widget.minW || 3;
        const minH = widget.minH || 2;
        const layoutX = Number(layout.x);
        const layoutY = Number(layout.y);
        const layoutW = Number(layout.w);
        const layoutH = Number(layout.h);
        const width = Math.min(12, Math.max(minW, Number.isFinite(layoutW) && layoutW > 0 ? layoutW : fallback.w));
        normalized[key] = {
          x: Math.min(12 - width, Math.max(0, Number.isFinite(layoutX) ? layoutX : fallback.x)),
          y: Math.max(0, Number.isFinite(layoutY) ? layoutY : fallback.y),
          w: width,
          h: Math.max(minH, Number.isFinite(layoutH) && layoutH > 0 ? layoutH : fallback.h)
        };
      });
      return normalized;
    },
    defaultDashboardWidgetLayout(key) {
      const widget = this.dashboardWidgetCatalog.find(item => item.key === key) || {};
      const index = Math.max(0, this.dashboardWidgets.indexOf(key));
      const defaultWidth = widget.w || 4;
      return {
        x: (index * defaultWidth) % 12,
        y: Math.floor((index * defaultWidth) / 12) * 4,
        w: defaultWidth,
        h: widget.h || 4
      };
    },
    nextDashboardWidgetPosition(key) {
      const widget = this.dashboardWidgetCatalog.find(item => item.key === key) || {};
      const layouts = Object.values(this.dashboardLayouts);
      const maxY = layouts.length
        ? Math.max(...layouts.map(layout => (layout.y || 0) + (layout.h || 4)))
        : this.activeDashboardWidgets.length
          ? Math.ceil(this.activeDashboardWidgets.length / 3) * 4
          : 0;
      return {
        x: 0,
        y: maxY,
        w: widget.w || 4,
        h: widget.h || 4
      };
    },
    showDashboardWidgetFeedback(message) {
      this.dashboardWidgetFeedback = message;
      clearTimeout(this.dashboardWidgetFeedbackTimer);
      this.dashboardWidgetFeedbackTimer = setTimeout(() => {
        this.dashboardWidgetFeedback = "";
      }, 2600);
    },
    resetDashboardWidgets() {
      this.dashboardWidgets = ["shortcuts", "whatsapp", "notifications"];
      this.dashboardLayouts = {};
      this.dashboardWidgetMenu = false;
      this.dashboardEditMode = true;
      this.saveDashboardWidgets();
      this.initDashboardGrid();
      this.showDashboardWidgetFeedback("Layout sugerido aplicado.");
    },
    toggleDashboardEditMode() {
      if (this.dashboardEditMode) {
        this.captureDashboardGridLayouts();
        this.dashboardEditMode = false;
        this.dashboardLayouts = this.normalizeDashboardLayouts(this.dashboardLayouts);
        this.saveDashboardWidgets();
        this.$nextTick(() => {
          this.initDashboardGrid();
          this.showDashboardWidgetFeedback("Layout salvo.");
        });
        return;
      }
      this.dashboardEditMode = true;
      this.dashboardLayouts = this.normalizeDashboardLayouts(this.dashboardLayouts);
      this.$nextTick(() => {
        this.initDashboardGrid();
        this.showDashboardWidgetFeedback("Edicao ativada. Arraste ou redimensione os widgets.");
      });
    },
    applyDashboardGridMode() {
      if (!this.dashboardGrid) return;
      if (typeof this.dashboardGrid.setStatic === "function") {
        this.dashboardGrid.setStatic(!this.dashboardEditMode);
      } else {
        this.dashboardGrid.enableMove(this.dashboardEditMode);
        this.dashboardGrid.enableResize(this.dashboardEditMode);
      }
    },
    captureDashboardGridLayouts() {
      if (!this.dashboardGrid) return;
      const layouts = { ...this.dashboardLayouts };
      this.dashboardGrid.engine.nodes.forEach(node => {
        const key = node.el && node.el.getAttribute("gs-id");
        if (!key) return;
        const widget = this.dashboardWidgetCatalog.find(catalogWidget => catalogWidget.key === key) || {};
        layouts[key] = {
          x: Math.max(0, node.x || 0),
          y: Math.max(0, node.y || 0),
          w: Math.min(12, Math.max(widget.minW || 3, node.w || widget.w || 4)),
          h: Math.max(widget.minH || 2, node.h || widget.h || 4)
        };
      });
      this.dashboardLayouts = this.normalizeDashboardLayouts(layouts);
    },
    initDashboardGrid() {
      this.$nextTick(() => {
        if (!this.$refs.dashboardGrid) return;
        if (this.dashboardGrid) {
          this.dashboardGrid.destroy(false);
          this.dashboardGrid = null;
        }
        this.dashboardGrid = GridStack.init(
          {
            column: 12,
            cellHeight: 104,
            margin: 14,
            float: false,
            animate: true,
            minRow: 2,
            handle: ".dashboard-card-header",
            staticGrid: !this.dashboardEditMode,
            disableResize: !this.dashboardEditMode,
            disableDrag: !this.dashboardEditMode,
            resizable: {
              handles: "se"
            }
          },
          this.$refs.dashboardGrid
        );
        this.dashboardGrid.on("change", (event, items) => {
          if (!this.dashboardEditMode) return;
          if (!items || !items.length) return;
          const layouts = { ...this.dashboardLayouts };
          items.forEach(item => {
            const key = item.el && item.el.getAttribute("gs-id");
            if (!key) return;
            const widget = this.dashboardWidgetCatalog.find(catalogWidget => catalogWidget.key === key) || {};
            layouts[key] = {
              x: Number.isFinite(item.x) ? item.x : 0,
              y: Number.isFinite(item.y) ? item.y : 0,
              w: Math.max(widget.minW || 3, item.w || widget.w || 4),
              h: Math.max(widget.minH || 2, item.h || widget.h || 4)
            };
          });
          this.dashboardLayouts = layouts;
          this.saveDashboardWidgets();
        });
        this.applyDashboardGridMode();
      });
    },
    isDashboardWidgetActive(key) {
      return this.dashboardWidgets.includes(key);
    },
    dashboardWidgetIndex(key) {
      return this.dashboardWidgets.indexOf(key);
    },
    addDashboardWidget(key) {
      if (this.dashboardWidgets.includes(key)) {
        this.showDashboardWidgetFeedback("Esse widget ja esta na dashboard.");
        return;
      }
      const widget = this.dashboardWidgetCatalog.find(item => item.key === key);
      this.dashboardWidgets = [...this.dashboardWidgets, key];
      this.dashboardEditMode = true;
      this.dashboardLayouts = {
        ...this.dashboardLayouts,
        [key]: this.nextDashboardWidgetPosition(key)
      };
      this.dashboardWidgetMenu = false;
      this.saveDashboardWidgets();
      this.initDashboardGrid();
      this.showDashboardWidgetFeedback(`${widget ? widget.title : "Widget"} adicionado. Arraste para organizar.`);
    },
    removeDashboardWidget(key) {
      if (this.dashboardWidgets.length === 1) return;
      this.dashboardWidgets = this.dashboardWidgets.filter(widgetKey => widgetKey !== key);
      this.dashboardEditMode = true;
      const layouts = { ...this.dashboardLayouts };
      delete layouts[key];
      this.dashboardLayouts = layouts;
      this.saveDashboardWidgets();
      this.initDashboardGrid();
    },
    moveDashboardWidget(index, direction) {
      const targetIndex = index + direction;
      if (index < 0 || targetIndex < 0 || targetIndex >= this.dashboardWidgets.length) return;
      const widgets = [...this.dashboardWidgets];
      const [widget] = widgets.splice(index, 1);
      widgets.splice(targetIndex, 0, widget);
      this.dashboardWidgets = widgets;
      this.saveDashboardWidgets();
      this.initDashboardGrid();
    },
    loadDashboardDeliveries(period) {
      return externalMovimentationService
        .listar_deliveries({
          period,
          include_active: period === "last7",
          dataInicio: period === "range" ? this.deliveryRangeStart : "",
          dataFim: period === "range" ? this.deliveryRangeEnd : ""
        })
        .then(res => {
          this.dashboardDeliveries = {
            ...this.dashboardDeliveries,
            [period]: res.data || { docs: [], summary: {} }
          };
        });
    },
    loadDashboardDeliveryMetrics() {
      return externalMovimentationService
        .delivery_metrics({
          dataInicio: this.deliveryRangeStart,
          dataFim: this.deliveryRangeEnd
        })
        .then(res => {
          this.dashboardDeliveryMetrics = res.data || this.dashboardDeliveryMetrics;
        });
    },
    loadDashboardDeliveryData() {
      if (!this.get_permission_user["ver-entregas"]) return;
      this.dashboardDeliveriesLoading = true;
      Promise.all([
        this.loadDashboardDeliveries("last7"),
        this.loadDashboardDeliveryMetrics()
      ]).finally(() => {
        this.dashboardDeliveriesLoading = false;
        this.scheduleDashboardDeliveryMapRender();
      });
    },
    dashboardDeliveryItems(period) {
      return this.dashboardDeliveries[period] && this.dashboardDeliveries[period].docs || [];
    },
    dashboardDeliveryStatus(status) {
      return this.dashboardDeliveryStatuses.find(item => item.value === status) || {
        color: "#78909c",
        icon: "mdi-truck-delivery-outline",
        label: status || "Sem status"
      };
    },
    dashboardDeliveryStatusColor(status) {
      return this.dashboardDeliveryStatus(status).color;
    },
    dashboardDeliveryStatusIcon(status) {
      return this.dashboardDeliveryStatus(status).icon;
    },
    dashboardDeliveryMarkerLabel(delivery) {
      const client = this.dashboardClientName(delivery);
      return client.split(" ").filter(Boolean).slice(0, 2).join(" ") || "Entrega";
    },
    dashboardDeliveryMarkerStyle(delivery) {
      const coords = this.dashboardDeliveryCoordinates(delivery);
      let x = 50;
      let y = 50;
      if (coords) {
        x = ((Math.abs(coords.lng) * 1000) % 76) + 12;
        y = ((Math.abs(coords.lat) * 1000) % 68) + 16;
      } else {
        const seed = String(delivery._id || "").split("").reduce((sum, char) => sum + char.charCodeAt(0), 0);
        x = (seed % 76) + 12;
        y = ((seed * 7) % 68) + 16;
      }
      return { left: `${x}%`, top: `${y}%` };
    },
    dashboardDeliveryCoordinates(delivery = {}) {
      const candidates = [
        delivery.address_destiny,
        delivery.destination,
        delivery.delivery_address,
        delivery.address,
        delivery.endereco,
        delivery.sale_summary && delivery.sale_summary.address_destiny,
        delivery.sale_summary && delivery.sale_summary.delivery_address,
        delivery.sale_summary && delivery.sale_summary.address,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.address_destiny,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.delivery_address,
        delivery.sale_summary && delivery.sale_summary.compra && delivery.sale_summary.compra.endereco,
        delivery.client && delivery.client.address,
        delivery.client && delivery.client.endereco,
      ];
      for (const candidate of candidates) {
        const coords = this.dashboardCoordinatesFrom(candidate);
        if (coords) return coords;
      }
      return null;
    },
    dashboardDriverCoordinates(delivery = {}) {
      return this.dashboardCoordinatesFrom(
        delivery.driver_location ||
        delivery.executor && delivery.executor.location ||
        delivery.executor && delivery.executor.current_location ||
        delivery.executor && delivery.executor.last_location ||
        delivery.executor && delivery.executor.geo
      );
    },
    dashboardCoordinatesFrom(value = {}) {
      if (!value) return null;
      const candidates = [
        value,
        value.location,
        value.coordinates,
        value.geo,
        value.position,
        value.geometry && value.geometry.location,
        value.current_location,
        value.last_location,
        value.address,
        value.address && value.address.location,
        value.address && value.address.coordinates,
        value.address && value.address.geometry && value.address.geometry.location,
        value.endereco,
        value.endereco && value.endereco.location,
        value.endereco && value.endereco.coordinates,
        value.endereco && value.endereco.geometry && value.endereco.geometry.location,
        value.address_destiny,
        value.address_destiny && value.address_destiny.location,
        value.address_destiny && value.address_destiny.coordinates,
        value.address_destiny && value.address_destiny.geometry && value.address_destiny.geometry.location,
      ];
      for (const candidate of candidates) {
        const lat = Number(candidate && (candidate.lat || candidate.latitude));
        const lng = Number(candidate && (candidate.lng || candidate.lon || candidate.long || candidate.longitude));
        if (Number.isFinite(lat) && Number.isFinite(lng)) return { lat, lng };
      }
      return null;
    },
    dashboardCurrentUnity() {
      const selectedUnityId = this.deliveryMapFilters.unity || this.getLoggedUser?.unity || this.getLoggedUser?.unidade;
      const allUnities = [
        ...(this.getLoggedUser && Array.isArray(this.getLoggedUser.unities) ? this.getLoggedUser.unities : []),
        ...(this.getLoggedUser && Array.isArray(this.getLoggedUser.unidades) ? this.getLoggedUser.unidades : []),
        this.getLoggedUser && this.getLoggedUser.unity,
        this.getLoggedUser && this.getLoggedUser.unidade,
        this.getLoggedUser && this.getLoggedUser.activeUnity,
        this.getLoggedUser && this.getLoggedUser.active_unity,
      ].filter(Boolean);
      if (!selectedUnityId) return allUnities[0] || null;
      return allUnities.find(unity => String(unity._id || unity.id || unity) === String(selectedUnityId._id || selectedUnityId.id || selectedUnityId)) ||
        (typeof selectedUnityId === "object" ? selectedUnityId : allUnities[0] || null);
    },
    dashboardTenant() {
      const logged = this.getLoggedUser || {};
      return logged.activeTenant && typeof logged.activeTenant === "object"
        ? logged.activeTenant
        : Array.isArray(logged.tenant) ? logged.tenant[0] : logged.tenant || {};
    },
    dashboardMapFallbackCenter() {
      const unityCoords = this.dashboardCoordinatesFrom(this.dashboardCurrentUnity());
      if (unityCoords) return unityCoords;
      if (this.dashboardOperationalMapCenter) return this.dashboardOperationalMapCenter;
      const tenantCoords = this.dashboardCoordinatesFrom(this.dashboardTenant());
      if (tenantCoords) return tenantCoords;
      if (this.dashboardBrowserMapCenter) return this.dashboardBrowserMapCenter;
      return { lat: -14.235004, lng: -51.92528 };
    },
    loadDashboardMapCenter() {
      this.$run("marketplaces/get-map-center", {
        unity: this.deliveryMapFilters.unity || null
      }).then(response => {
        const center = response.data && response.data.center;
        const coords = this.dashboardCoordinatesFrom(center);
        if (!coords) return;
        this.dashboardOperationalMapCenter = coords;
        this.scheduleDashboardDeliveryMapRender(true);
      }).catch(() => {});
    },
    requestDashboardBrowserLocation() {
      if (!navigator.geolocation) return;
      navigator.geolocation.getCurrentPosition(
        position => {
          this.dashboardBrowserMapCenter = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          this.scheduleDashboardDeliveryMapRender(true);
        },
        () => {},
        { enableHighAccuracy: true, timeout: 10000, maximumAge: 120000 }
      );
    },
    scheduleDashboardDeliveryMapRender(reset = false) {
      clearTimeout(this.dashboardDeliveryMapRenderTimer);
      this.dashboardDeliveryMapRenderTimer = setTimeout(() => {
        this.$nextTick(() => this.renderDashboardDeliveryMap(reset));
      }, 80);
    },
    dashboardDeliveryMapContainer() {
      const ref = this.$refs.dashboardDeliveryMap;
      const container = Array.isArray(ref) ? ref.find(item => item && item.nodeType === 1) : ref;
      if (!container || container.nodeType !== 1 || typeof container.addEventListener !== "function") return null;
      return container;
    },
    renderDashboardDeliveryMap(reset = false) {
      const container = this.dashboardDeliveryMapContainer();
      if (!container) return;
      this.dashboardDeliveryMapLoading = true;
      Promise.resolve()
        .then(() => {
          const points = this.dashboardDeliveryMapPoints;
          const fallbackCenter = this.dashboardMapFallbackCenter();
          const fallbackLatLng = [fallbackCenter.lat, fallbackCenter.lng];
          if (!this.dashboardDeliveryMap || reset) {
            if (this.dashboardDeliveryMap) this.dashboardDeliveryMap.remove();
            this.dashboardDeliveryMap = L.map(container, {
              center: fallbackLatLng,
              zoom: 13,
              zoomControl: true,
              scrollWheelZoom: true
            });
            const tileConfig = this.dashboardDeliveryMapTileConfig();
            L.tileLayer(tileConfig.url, tileConfig.options).addTo(this.dashboardDeliveryMap);
          }

          this.dashboardDeliveryRouteLayers.forEach(layer => layer.remove());
          this.dashboardDeliveryRouteLayers = [];
          this.dashboardDeliveryMarkers.forEach(marker => marker.remove());
          this.dashboardDeliveryMarkers = [];

          const routeLines = this.dashboardDeliveryRouteLines();
          if (!points.length && !routeLines.length) {
            this.dashboardDeliveryMap.invalidateSize();
            this.dashboardDeliveryMap.setView(fallbackLatLng, 13);
            return;
          }

          const bounds = [];
          routeLines.forEach(route => {
            const statusColor = this.dashboardDeliveryStatusColor(route.delivery.status);
            const routeBaseShadow = L.polyline(route.coords, {
              color: "#92400e",
              lineCap: "round",
              lineJoin: "round",
              opacity: .2,
              weight: 7
            }).addTo(this.dashboardDeliveryMap);
            const routeBase = L.polyline(route.coords, {
              color: "#fbbf24",
              dashArray: route.isFallback ? "8 10" : null,
              lineCap: "round",
              lineJoin: "round",
              opacity: .94,
              weight: 4
            }).addTo(this.dashboardDeliveryMap);
            routeBase.bindPopup(this.dashboardDeliveryRoutePopupHtml(route.delivery));
            this.dashboardDeliveryRouteLayers.push(routeBaseShadow, routeBase);
            if (route.progressCoords.length > 1) {
              const progressLine = L.polyline(route.progressCoords, {
                color: "#16a34a",
                lineCap: "round",
                lineJoin: "round",
                opacity: .96,
                weight: 5
              }).addTo(this.dashboardDeliveryMap);
              progressLine.bindPopup(this.dashboardDeliveryRoutePopupHtml(route.delivery));
              this.dashboardDeliveryRouteLayers.push(progressLine);
            }
            route.coords.forEach(coords => bounds.push(coords));
          });

          points.forEach(point => {
            const marker = L.marker([point.coords.lat, point.coords.lng], {
              icon: this.dashboardDeliveryLeafletIcon(point, L)
            }).addTo(this.dashboardDeliveryMap);
            marker.bindPopup(this.dashboardDeliveryPopupHtml(point));
            marker.on("popupopen", () => {
              const button = document.getElementById(`dashboard-delivery-${point.type}-${point.delivery._id}`);
              if (button) button.onclick = () => this.openDelivery(point.delivery);
            });
            this.dashboardDeliveryMarkers.push(marker);
            bounds.push([point.coords.lat, point.coords.lng]);
          });

          this.dashboardDeliveryMap.invalidateSize();
          if (bounds.length === 1) {
            this.dashboardDeliveryMap.setView(bounds[0], 14);
          } else {
            this.dashboardDeliveryMap.fitBounds(bounds, { padding: [36, 36] });
          }
        })
        .catch(error => console.error(error))
        .finally(() => {
          this.dashboardDeliveryMapLoading = false;
        });
    },
    dashboardDeliveryMapTileConfig() {
      if (this.dark) {
        return {
          url: "https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png",
          options: {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> &copy; <a href="https://carto.com/attributions">CARTO</a>',
            maxZoom: 20,
            subdomains: "abcd",
          },
        };
      }
      return {
        url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
        options: {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          maxZoom: 19,
        },
      };
    },
    dashboardDeliveryRouteLines() {
      return this.dashboardDeliveryMapItems
        .filter(delivery => String(delivery.status || "").toLowerCase() === "on_the_way")
        .map(delivery => {
          const coords = this.dashboardDeliveryRouteCoordinates(delivery);
          const driverCoords = this.dashboardDriverCoordinates(delivery);
          const routeSummary = this.dashboardDeliveryRouteSummaryWithPolyline(delivery);
          return {
            delivery,
            coords,
            progressCoords: this.dashboardDeliveryRouteProgressCoordinates(coords, driverCoords),
            isFallback: !routeSummary.overview_polyline
          };
        })
        .filter(route => route.coords.length > 1);
    },
    dashboardDeliveryRouteCoordinates(delivery = {}) {
      const routeSummary = this.dashboardDeliveryRouteSummaryWithPolyline(delivery);
      const encodedPolyline = routeSummary.overview_polyline || routeSummary.polyline || routeSummary.encoded_polyline;
      const decoded = this.dashboardDecodePolyline(encodedPolyline);
      if (decoded.length > 1) return decoded;
      return [];
    },
    dashboardDeliveryRouteSummaryWithPolyline(delivery = {}) {
      const summaries = [
        delivery && delivery.route_summary,
        ...(Array.isArray(delivery && delivery.status_history)
          ? [...delivery.status_history].reverse().map(item => item && item.route_summary)
          : []),
      ];
      return summaries.find(summary => summary && (
        summary.overview_polyline ||
        summary.polyline ||
        summary.encoded_polyline
      )) || {};
    },
    dashboardDeliveryRouteProgressCoordinates(routeCoords = [], driverCoords = null) {
      if (!routeCoords.length || !driverCoords) return [];
      const driverPoint = [driverCoords.lat, driverCoords.lng];
      let closestIndex = 0;
      let closestDistance = Number.MAX_SAFE_INTEGER;

      routeCoords.forEach((coords, index) => {
        const distance = this.dashboardDistanceBetweenLatLng(coords, driverPoint);
        if (distance < closestDistance) {
          closestDistance = distance;
          closestIndex = index;
        }
      });

      return [
        ...routeCoords.slice(0, closestIndex + 1),
        driverPoint
      ];
    },
    dashboardDistanceBetweenLatLng(origin, destination) {
      if (!origin || !destination) return Number.MAX_SAFE_INTEGER;
      const fromLat = Number(origin[0]);
      const fromLng = Number(origin[1]);
      const toLat = Number(destination[0]);
      const toLng = Number(destination[1]);
      if (![fromLat, fromLng, toLat, toLng].every(Number.isFinite)) return Number.MAX_SAFE_INTEGER;

      const radius = 6371;
      const toRadians = degrees => degrees * Math.PI / 180;
      const deltaLat = toRadians(toLat - fromLat);
      const deltaLng = toRadians(toLng - fromLng);
      const a = Math.sin(deltaLat / 2) * Math.sin(deltaLat / 2) +
        Math.cos(toRadians(fromLat)) * Math.cos(toRadians(toLat)) *
        Math.sin(deltaLng / 2) * Math.sin(deltaLng / 2);
      return radius * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    },
    dashboardDecodePolyline(encoded = "") {
      if (!encoded || typeof encoded !== "string") return [];
      let index = 0;
      let lat = 0;
      let lng = 0;
      const coordinates = [];

      while (index < encoded.length) {
        let shift = 0;
        let result = 0;
        let byte = null;
        do {
          byte = encoded.charCodeAt(index++) - 63;
          result |= (byte & 0x1f) << shift;
          shift += 5;
        } while (byte >= 0x20);
        lat += result & 1 ? ~(result >> 1) : result >> 1;

        shift = 0;
        result = 0;
        do {
          byte = encoded.charCodeAt(index++) - 63;
          result |= (byte & 0x1f) << shift;
          shift += 5;
        } while (byte >= 0x20);
        lng += result & 1 ? ~(result >> 1) : result >> 1;

        coordinates.push([lat / 1e5, lng / 1e5]);
      }

      return coordinates;
    },
    dashboardDeliveryLeafletIcon(point, L) {
      return L.divIcon({
        className: "dashboard-delivery-leaflet-marker",
        html: `
          <div class="dashboard-delivery-marker dashboard-delivery-marker-${point.type}" style="height:62px;position:relative;width:52px;">
            ${this.dashboardDeliveryPinSvg(point)}
            <span class="dashboard-delivery-marker-icon" style="display:block;height:22px;left:15px;position:absolute;top:15px;width:22px;z-index:2;">${this.dashboardDeliveryMarkerSvg(point.type)}</span>
          </div>
        `,
        iconSize: [52, 62],
        iconAnchor: [26, 58],
        popupAnchor: [0, -54]
      });
    },
    dashboardDeliveryPinSvg(point) {
      const rawId = `dash-pin-${point.type}-${point.delivery && point.delivery._id || Date.now()}`;
      const id = String(rawId).replace(/[^a-zA-Z0-9_-]/g, "");
      const isDriver = point.type === "driver";
      const stops = isDriver
        ? [
          ["0%", "#16a34a"],
          ["34%", "#22c55e"],
          ["58%", "#0ea5e9"],
          ["100%", "#2563eb"],
        ]
        : [
          ["0%", "#ef4444"],
          ["30%", "#f97316"],
          ["55%", "#facc15"],
          ["78%", "#22c55e"],
          ["100%", "#3b82f6"],
        ];
      const gradientStops = stops.map(([offset, color]) => `<stop offset="${offset}" stop-color="${color}" />`).join("");
      return `
        <svg class="dashboard-delivery-marker-shape" style="display:block;height:62px;width:52px;" viewBox="0 0 64 72" aria-hidden="true">
          <defs>
            <linearGradient id="${id}-paint" x1="10" y1="8" x2="54" y2="64" gradientUnits="userSpaceOnUse">
              ${gradientStops}
            </linearGradient>
            <radialGradient id="${id}-core" cx="30%" cy="22%" r="78%">
              <stop offset="0%" stop-color="#fff7ad" />
              <stop offset="48%" stop-color="#ffd23f" />
              <stop offset="100%" stop-color="#f59e0b" />
            </radialGradient>
            <linearGradient id="${id}-shine" x1="16" y1="10" x2="46" y2="38" gradientUnits="userSpaceOnUse">
              <stop offset="0%" stop-color="#ffffff" stop-opacity=".86" />
              <stop offset="100%" stop-color="#ffffff" stop-opacity="0" />
            </linearGradient>
          </defs>
          <path fill="url(#${id}-paint)" d="M32 4C18.2 4 7 15.2 7 29c0 19.6 25 39 25 39s25-19.4 25-39C57 15.2 45.8 4 32 4Z" />
          <path fill="rgba(255,255,255,.22)" d="M13 29C13 17.6 21.6 9.8 33.5 8.7C25.6 12.2 18.6 21 18 32.2c-.5 9.1 4.2 18.3 10.1 26.4C21.5 52.2 13 40.2 13 29Z" />
          <circle cx="32" cy="29" r="18" fill="rgba(10,20,30,.22)" />
          <circle cx="32" cy="29" r="16" fill="url(#${id}-core)" />
          <path fill="url(#${id}-shine)" d="M21 23c4.2-8.6 16.7-9.5 22.5-2.5c-6.6-2.9-15.5-1.8-22.5 2.5Z" />
        </svg>
      `;
    },
    dashboardDeliveryMarkerSvg(type) {
      if (type === "driver") {
        return `
          <svg style="display:block;height:22px;width:22px;" viewBox="0 0 24 24" aria-hidden="true">
            <path fill="#ffffff" d="M3 7a2 2 0 0 1 2-2h9v9H3V7Z" />
            <path fill="#ffffff" d="M15 9h3.2c.5 0 1 .24 1.3.64L22 13v1h-7V9Z" />
            <path fill="#ffffff" d="M7 20a2.3 2.3 0 1 0 0-4.6A2.3 2.3 0 0 0 7 20ZM18 20a2.3 2.3 0 1 0 0-4.6A2.3 2.3 0 0 0 18 20Z" />
          </svg>
        `;
      }
      return `
        <svg style="display:block;height:22px;width:22px;" viewBox="0 0 24 24" aria-hidden="true">
          <path fill="#ffffff" d="M4 20V9.5L12 4l8 5.5V20h-5v-6H9v6H4Z" />
          <path fill="#ffffff" d="M7 10h10v2H7v-2ZM6.5 20h11l2 2h-15l2-2Z" />
        </svg>
      `;
    },
    dashboardDeliveryPopupHtml(point) {
      const delivery = point.delivery;
      const id = `dashboard-delivery-${point.type}-${delivery._id}`;
      const status = this.dashboardDeliveryStatus(delivery.status);
      const typeLabel = point.type === "driver" ? "Entregador" : "Obra de destino";
      const logs = this.dashboardDeliveryLogs(delivery).slice(-6).reverse();
      const logsHtml = logs.length
        ? logs.map(log => `
          <li>
            <b>${this.escapeHtml(log.type)}</b>
            <span>${this.escapeHtml(log.description)}</span>
            <small>${this.escapeHtml(log.dateLabel)} ${this.escapeHtml(log.executorName)}</small>
          </li>
        `).join("")
        : "<li><span>Nenhum log registrado ainda.</span></li>";
      return `
        <div class="dashboard-delivery-info-window">
          <strong>${this.escapeHtml(typeLabel)} - ${this.escapeHtml(this.dashboardClientName(delivery))}</strong>
          <span>Venda #${this.escapeHtml(this.dashboardSaleNumber(delivery))}</span>
          <small>${this.escapeHtml(this.dashboardUserName(delivery.executor))}</small>
          <small>${this.escapeHtml(this.dashboardAddressLabel(delivery.address_destiny))}</small>
          <div class="dashboard-delivery-info-route">
            <span>${this.escapeHtml(delivery.route_summary && delivery.route_summary.distance_text || "")}</span>
            <span>${this.escapeHtml(delivery.route_summary && delivery.route_summary.duration_text || "")}</span>
          </div>
          <ul>${logsHtml}</ul>
          <button id="${id}" type="button" style="background:${status.color};border:0;border-radius:6px;color:#fff;cursor:pointer;font-weight:700;margin-top:8px;padding:7px 10px;">Abrir entrega</button>
        </div>
      `;
    },
    dashboardDeliveryRoutePopupHtml(delivery = {}) {
      const summary = delivery.route_summary || {};
      return `
        <div class="dashboard-delivery-info-window">
          <strong>Rota em andamento</strong>
          <span>${this.escapeHtml(this.dashboardClientName(delivery))} - Venda #${this.escapeHtml(this.dashboardSaleNumber(delivery))}</span>
          <small>${this.escapeHtml(summary.distance_text || "")}</small>
          <small>${this.escapeHtml(summary.duration_text || "")}</small>
        </div>
      `;
    },
    dashboardDeliveryLogs(delivery = {}) {
      const history = Array.isArray(delivery.status_history) ? delivery.status_history : [];
      const comments = Array.isArray(delivery.comments) ? delivery.comments : [];
      const statusLogs = history.map(item => ({
        type: "Status",
        description: item.description || this.dashboardDeliveryStatus(item.status).label || "Status atualizado",
        date: item.created_at || item.date,
        dateLabel: this.dashboardLogDateLabel(item.created_at || item.date),
        executorName: this.dashboardUserName(item.executor)
      }));
      const commentLogs = comments.map(item => ({
        type: item.attachment ? "Foto/Comentário" : "Comentário",
        description: item.description || "Comentário registrado",
        date: item.created_at || item.date,
        dateLabel: this.dashboardLogDateLabel(item.created_at || item.date),
        executorName: this.dashboardUserName(item.executor)
      }));
      return [...statusLogs, ...commentLogs]
        .sort((a, b) => new Date(a.date || 0).getTime() - new Date(b.date || 0).getTime());
    },
    dashboardLatestDeliveryLog(delivery = {}, pointType = "") {
      const logs = this.dashboardDeliveryLogs(delivery);
      if (!logs.length) return null;
      const preferred = pointType === "driver"
        ? logs.filter(log => log.type === "Status")
        : logs.filter(log => log.type !== "Status");
      return (preferred.length ? preferred : logs).slice(-1)[0];
    },
    dashboardLogDateLabel(value) {
      if (!value) return "";
      const date = this.$moment ? this.$moment(value) : null;
      if (date && date.isValid && date.isValid()) return date.format("DD/MM HH:mm");
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return "";
      return parsed.toLocaleString("pt-BR", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
    },
    truncateDashboardText(value, limit = 60) {
      const text = String(value || "").trim();
      if (text.length <= limit) return text;
      return `${text.slice(0, Math.max(0, limit - 1))}…`;
    },
    escapeHtml(value) {
      return String(value || "")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#039;");
    },
    dashboardDeliverySummary() {
      const payload = this.dashboardDeliveries[this.activeDashboardDeliveryPeriod] || {};
      const summary = payload.summary || {};
      return [
        { label: "Agendadas", value: summary.waiting || 0, color: "orange" },
        { label: "Em rota", value: summary.on_the_way || 0, color: "green" },
        { label: "Concluídas", value: summary.done || 0, color: "blue" },
      ];
    },
    openDelivery(delivery) {
      if (this.get_permission_user["fazer-entregas"]) {
        this.$router.push(`/entregas?event=${delivery._id}`);
        return;
      }
      if (this.get_permission_user["agenda"]) {
        this.$router.push(`/agenda?event=${delivery._id}`);
      }
    },
    dashboardClientName(delivery) {
      return delivery.client && delivery.client.nome ||
        delivery.sale_summary && delivery.sale_summary.client && delivery.sale_summary.client.nome ||
        "Cliente não informado";
    },
    dashboardAddressLabel(address = {}) {
      return [
        address.street,
        address.number ? `nº ${address.number}` : "",
        address.bairro,
        address.city || address.cidade
      ].filter(Boolean).join(", ") || "Endereço não informado";
    },
    dashboardSaleNumber(delivery) {
      return delivery.sale_summary && delivery.sale_summary.id_transacao || delivery.transaction || "-";
    },
    dashboardUserName(user) {
      return user && user.nome || "Não informado";
    },
    deliveryMetricLabel(metric) {
      if (!metric) return "-";
      if (metric.days >= 1) return `${metric.days} dias`;
      return `${Number(metric.hours || 0).toFixed(1)} horas`;
    },
    openEvent(event) {
      if (this.tabCalendar == 0 && !this.get_permission_user["agenda"]) {
        this.$router.push("/minha-agenda?event=" + event._id);
      }

      //tab 1 sempre Ã© a agenda pessoal
      if (this.tabCalendar == 1) {
        this.$router.push("/minha-agenda?event=" + event._id);
      }

      //tem permissÃ£o, entÃ£o carrega na tab 0 a agenda geral de hoje
      if (this.tabCalendar == 0 && this.get_permission_user["agenda"]) {
        this.$router.push("/agenda?event=" + event._id);
      }
    },
    getColor(value) {
      const status = {
        waiting: "orange",
        done: "blue",
        canceled: "red",
        on_the_way: "green",
        lost: "red"
      };
      return status[value];
    },
    getStatus(value) {
      const status = {
        waiting: "Agendado",
        done: "Concluído",
        canceled: "Cancelado",
        on_the_way: "Em andamento",
        lost: "Perdido"
      };
      return status[value];
    },
    getIcon(value) {
      const status = {
        waiting: "mdi-clock-outline",
        done: "mdi-check-circle",
        canceled: "mdi-close-circle",
        on_the_way: "mdi-truck-delivery",
        lost: "mdi-alert-circle-outline"
      };
      return status[value];
    },
    saveStateTheme(dark) {
      if (dark) {
        localStorage.dark = "true";
      } else {
        localStorage.removeItem("dark");
      }
      this.dark = Boolean(dark);
      this.$theme.dark = this.dark;
      this.$theme.light = !this.dark;
      this.$theme.background = this.dark ? "#0b141a" : "#f5f5f5";
      if (this.$vuetify && this.$vuetify.theme) {
        this.$vuetify.theme.dark = this.dark;
      }
      EventBus.$emit("theme:changed", { dark: this.dark });
      this.chartSales = false;
      this.chartValues = false;
      this.showAllCharts = false;
      // this.$refs.chartValue.unmountChart();
      // this.$refs.chartSales.unmountChart();
      setTimeout(() => {
        this.chartValues = true;
        this.chartSales = true;
        // this.$refs.chartValue.montaChart();
        // this.$refs.chartSales.montaChart();
      }, 100);
      setTimeout(() => {
        this.showAllCharts = true;
        this.reflowDashboardGrid();
      }, 200);
    },
    reflowDashboardGrid() {
      this.dashboardLayouts = this.normalizeDashboardLayouts(this.dashboardLayouts);
      this.$nextTick(() => {
        window.requestAnimationFrame(() => {
          this.initDashboardGrid();
        });
      });
    },
    verifyTheme() {
      if (localStorage.dark === "true") {
        this.dark = true;
      }
    },
    notification_sound() {
      const audio = new Audio("call_in.mp3");
      audio.play();
    },
    abre_modal_view_notification(notify) {
      if (!notify.readed) {
        this.markNotificationAsReaded(notify);
      }
      const route = this.getLinkNotify(notify);
      if (!route || !route.link) return;
      this.$router.push(route.link);
    },
    getIconNotification(type) {
      const types = {
        new_comment: "mdi-comment-text-outline",
        new_sale: "mdi-cash-register",
        sale_updated: "mdi-satellite-variant",
        stock_low: "mdi-trending-down",
        stock_down: "mdi-basket-minus-outline",
        stock_up: "mdi-basket-plus-outline"
      };
      return types[type];
    },
    getTypeLinkByTypeNotification(notification) {
      const types = {
        invoice_payment: {
          title: "LanÃ§amento de caixa",
          icon: "mdi-receipt-text-check-outline"
        },
        new_comment: {
          title: "Novo comentÃ¡rio",
          icon: "mdi-comment-text-outline"
        },
        employee_balance_added: {
          title: "SalÃ¡rio adicionado manualmente",
          icon: "mdi-account-plus-outline"
        },
        employee_balance_withdraw: {
          title: "Vale emitido",
          icon: "mdi-account-minus-outline"
        },
        sale_updated: {
          title: "Venda atualizada",
          icon: "mdi-cash-register"
        },
        sale_approval_updated: {
          title: "Aprovação do orçamento atualizada",
          icon: "mdi-check-decagram-outline"
        },
        internal_chat_message: {
          title: "Mensagem interna",
          icon: "mdi-account-message"
        },
        stock_up: {
          title: "Estoque aumentado",
          icon: "mdi-cart-arrow-up"
        },
        stock_down: {
          title: "Estoque diminuido",
          icon: "mdi-cart-arrow-down"
        },
        stock_low: {
          title: "Estoque baixo",
          icon: "mdi-trending-down"
        },
        box_closed: {
          title: "Caixa fechado",
          icon: "mdi-cash-register"
        },
        box_opened: {
          title: "Caixa aberto",
          icon: "mdi-cash-register"
        },
        new_payment: {
          title: "Pagamento",
          icon: "mdi-cash-register"
        },
        new_comment_external_movimentation: {
          title: "Novo comentÃ¡rio",
          icon: "mdi-comment-text-outline"
        },
        new_external_movimentation: {
          title: "Novo agendamento",
          icon: "mdi-calendar-clock"
        },
        new_external_movimentation_viewed: {
          title: "O agendamento foi visualizado",
          icon: "mdi-calendar-clock"
        },
        external_movimentation_updated: {
          title: "Um agendamento foi atualizado",
          icon: "mdi-calendar-clock"
        },
        delivery_confirmation: {
          title: "ConfirmaÃ§Ã£o de entrega",
          icon: "mdi-truck-delivery-outline"
        },
        delivery_confirmation_whatsapp_queued: {
          title: "ConfirmaÃ§Ã£o de entrega enviada",
          icon: "mdi-whatsapp"
        },
        delivery_confirmation_whatsapp_pending: {
          title: "ConfirmaÃ§Ã£o de entrega pendente",
          icon: "mdi-alert-circle-outline"
        },
        assembly_offer_whatsapp_pending: {
          title: "Oferta de montagem pendente",
          icon: "mdi-tools"
        },
        collection_whatsapp_pending: {
          title: "Cobrança pendente",
          icon: "mdi-cash-clock"
        },
        collection_contact_registered: {
          title: "Contato de Cobrança registrado",
          icon: "mdi-note-edit-outline"
        },
        whatsapp_delivery_response: {
          title: "Resposta sobre entrega",
          icon: "mdi-truck-check-outline"
        },
        whatsapp_assembly_declined: {
          title: "Montagem recusada",
          icon: "mdi-tools"
        },
        whatsapp_assembly_requested: {
          title: "Montagem solicitada",
          icon: "mdi-tools"
        },
        whatsapp_approval_response: {
          title: "Resposta de aprovaÃ§Ã£o",
          icon: "mdi-check-decagram-outline"
        },
        whatsapp_collection_response: {
          title: "Resposta de Cobrança",
          icon: "mdi-cash-sync"
        },
        whatsapp_company_contact_notice: {
          title: "Aviso de contato da empresa",
          icon: "mdi-whatsapp"
        },
        transaction_unsigned: {
          title: "Registro da conferência de caixa foi Cancelado",
          icon: "mdi-calendar-clock"
        },
        transaction_signed: {
          title: "Registro da conferência de caixa foi Aprovado",
          icon: "mdi-success"
        },
        seller_signup: {
          title: "Um vendedor se cadastrou",
          icon: "mdi-account-plus-outline"
        },
        "signature-flow-initiated": {
          title: "Um novo cliente se cadastrou",
          icon: "mdi-account-plus-outline"
        },
        "signature-flow-progress": {
          title: "Um cliente criou sua loja",
          icon: "mdi-account-plus-outline"
        }
      };
      if (String(notification.type || "").startsWith("whatsapp_template_")) {
        return { title: "Mensagem automÃ¡tica", icon: "mdi-whatsapp" };
      }
      if (!types[notification.type])
        return { title: notification.type, icon: "help_outline" };
      if (String(notification.type || "").startsWith("whatsapp_template_")) {
        return {
          title: "Mensagem automÃ¡tica",
          link: `/whatsapp-atendimento`
        };
      }
      return types[notification.type] || {
        title: notification.type || "NotificaÃ§Ã£o",
        link: "/dashboard"
      };
    },
    getNotificationDescription(type) {
      const types = {
        new_comment: "Novo comentÃ¡rio",
        new_sale: "Nova venda",
        sale_updated: "Venda atualizada",
        sale_approval_updated: "Aprovação do orçamento atualizada",
        stock_low: "Estoque baixo",
        stock_up: "Entrada de estoque",
        stock_down: "SaÃ­da de estoque"
      };
      return types[type];
    },
    getSaleRealtimeEventDescription(event = {}) {
      const descriptions = {
        status: "Status da venda atualizado.",
        comment: "Novo comentário registrado na venda.",
        followers: "Participantes da venda atualizados.",
        appointment: "Novo agendamento criado para a venda.",
        payment: "Pagamento recebido para a venda.",
        sale_approval_updated: "Aprovação do orçamento atualizada."
      };
      return event && (event.description || descriptions[event.type]) || "Venda atualizada.";
    },
    getFriendlyNotificationDescription(notification) {
      if (!notification) return "";
      if (notification.type === "whatsapp_message_received") {
        return notification.description ||
          notification.message ||
          (notification.payload && (notification.payload.text || notification.payload.last_message_text)) ||
          "Nova mensagem recebida no WhatsApp";
      }
      if (notification.type === "sale_updated") {
        return notification.description ||
          (notification.payload && notification.payload.description) ||
          "Uma venda acompanhada por voce foi atualizada";
      }
      if (notification.type === "internal_chat_message") {
        return notification.description ||
          (notification.payload && notification.payload.text) ||
          "Nova mensagem interna";
      }
      return notification.description ||
        notification.message ||
        this.getNotificationDescription(notification.type) ||
        this.getTypeLinkByTypeNotification(notification).title;
    },
    getNotificationTitle(notification) {
      if (!notification) return "";
      if (notification.type === "whatsapp_message_received") {
        return this.getWhatsappNotificationContactName(notification);
      }
      if (notification.type === "internal_chat_message") {
        return this.getInternalChatNotificationSenderName(notification);
      }
      return this.getTypeLinkByTypeNotification(notification).title;
    },
    getNotificationSubtitle(notification) {
      if (!notification) return "";
      const description = this.getFriendlyNotificationDescription(notification);
      const title = this.getNotificationTitle(notification);
      if (["whatsapp_message_received", "internal_chat_message"].includes(notification.type) && description.includes(":")) {
        return description.split(":").slice(1).join(":").trim() || description;
      }
      if (description && description !== title) return description;
      return this.$moment(notification.created_at).fromNow();
    },
    getWhatsappNotificationContactName(notification) {
      const payload = notification.payload || {};
      const conversation = payload.conversation || notification.conversation || {};
      const client = payload.client || notification.client || conversation.client || {};
      return client.nome ||
        client.name ||
        payload.contact_name ||
        payload.contactName ||
        conversation.contact_name ||
        payload.sender_name ||
        notification.contact_name ||
        this.getNameFromNotificationDescription(notification) ||
        "Contato WhatsApp";
    },
    getInternalChatNotificationSenderName(notification) {
      const payload = notification.payload || {};
      const sender = payload.sender || notification.sender || {};
      if (sender.nome || sender.name) return sender.nome || sender.name;
      const description = this.getFriendlyNotificationDescription(notification);
      if (description.includes(":")) return description.split(":")[0].trim();
      return "Mensagem interna";
    },
    getNotificationAvatar(notification) {
      if (!notification) return "";
      const payload = notification.payload || {};
      const conversation = payload.conversation || notification.conversation || {};
      const client = payload.client || notification.client || conversation.client || {};
      const sender = payload.sender || notification.sender || {};
      const candidates = [
        client.profile_image,
        client.profileImage,
        client.photo,
        conversation.contact_picture_url,
        conversation.contact_picture,
        payload.contact_picture_url,
        payload.contact_picture,
        payload.avatar,
        payload.photo,
        sender.profile_image,
        sender.profileImage,
        sender.photo,
        notification.avatar,
        notification.photo
      ];
      const avatar = candidates.find(value => Array.isArray(value) ? value[0] : value);
      const avatarUrl = Array.isArray(avatar) ? avatar[0] || "" : avatar || "";
      if (avatarUrl) return avatarUrl;
      if (notification.type === "whatsapp_message_received") {
        return this.getNotificationShadcnAvatar(notification);
      }
      return "";
    },
    getNameFromNotificationDescription(notification) {
      const description = this.getFriendlyNotificationDescription(notification);
      if (!description.includes(":")) return "";
      return description.split(":")[0].trim();
    },
    getNotificationShadcnAvatar(notification) {
      const payload = notification.payload || {};
      const conversation = payload.conversation || notification.conversation || {};
      const client = payload.client || notification.client || conversation.client || {};
      const seed = `${client._id || ""}-${conversation.contact_phone || conversation.contact_id || conversation.chat_id || payload.conversation_id || this.getNotificationTitle(notification) || "whatsapp"}`;
      const avatarNumber = (this.hashString(seed) % 5) + 1;
      return `https://ui.shadcn.com/avatars/0${avatarNumber}.png`;
    },
    hashString(value) {
      return String(value || "").split("").reduce((hash, char) => ((hash << 5) - hash + char.charCodeAt(0)) >>> 0, 0);
    },
    entityId(value) {
      if (!value) return "";
      if (typeof value === "string") return value;
      return value._id || value.id || value.user_id || "";
    },
    collectEntityIds(target, keys) {
      return keys.flatMap(key => {
        const value = target?.[key];
        if (!value) return [];
        return Array.isArray(value) ? value.map(this.entityId) : [this.entityId(value)];
      }).map(String).filter(Boolean);
    },
    internalChatParticipantIds(detail = {}) {
      const conversation = detail.conversation || {};
      const message = detail.message || {};
      return [
        ...this.collectEntityIds(detail, ["participants", "participant_ids", "users"]),
        ...this.collectEntityIds(conversation, ["participants", "participant_ids", "users"]),
        ...this.collectEntityIds(message, ["sender", "recipient", "receiver", "to", "from"]),
        ...this.collectEntityIds(message, ["sender_id", "recipient_id", "receiver_id", "to_user_id", "from_user_id"])
      ].map(String).filter(Boolean);
    },
    isInternalChatForCurrentUser(detail) {
      const currentUserId = String(this.getLoggedUser?._id || "");
      const participants = [...new Set(this.internalChatParticipantIds(detail))];
      return Boolean(currentUserId && participants.length && participants.includes(currentUserId));
    },
    handleDashboardRealtime(event) {
      const detail = event ? event.detail : null;
      if (detail && detail.event && detail.event.type === "delivery_location") {
        if (this.get_permission_user["ver-entregas"]) this.loadDashboardDeliveryData();
        return;
      }
      if (detail && detail.sale_id) {
        if (detail.event && detail.event.type === "payment") {
          this.listar_gestordepedidos();
        }
        const eventDescription = this.getSaleRealtimeEventDescription(detail.event);
        this.notifications = [
          {
            _id: `local-sale-${detail.sale_id}-${Date.now()}`,
            type: "sale_updated",
            payload: { _id: detail.sale_id, description: eventDescription },
            description: eventDescription,
            created_at: new Date(),
            readed: false
          },
          ...this.notifications
        ];
      }
      if (detail && detail.external_movimentation) {
        this.notifications = [
          {
            _id: `local-appointment-${detail.external_movimentation._id || Date.now()}`,
            type: "new_external_movimentation",
            payload: { _id: detail.external_movimentation._id },
            description: detail.event?.description || "Novo agendamento criado.",
            created_at: new Date(),
            readed: false
          },
          ...this.notifications
        ];
        if (this.get_permission_user["ver-entregas"]) {
          this.loadDashboardDeliveryData();
        }
        return;
      }
      if (detail && detail.conversation && detail.message) {
        if (detail.message.sender && detail.message.sender._id) {
          if (!this.isInternalChatForCurrentUser(detail)) return;
          if (String(detail.message.sender._id) === String(this.getLoggedUser && this.getLoggedUser._id)) return;
          this.notifications = [
            {
              _id: `local-internal-${detail.message._id || Date.now()}`,
              type: "internal_chat_message",
              payload: {
                conversation_id: detail.conversation._id,
                text: detail.message.text || "Nova mensagem interna",
                sender_id: detail.message.sender._id
              },
              description: `${detail.message.sender.nome || "Funcionario"}: ${detail.message.text || "Nova mensagem interna"}`,
              created_at: new Date(),
              readed: false
            },
            ...this.notifications
          ];
          return;
        }
        this.notifications = [
          {
            _id: `local-whatsapp-${detail.message._id || Date.now()}`,
            type: "whatsapp_message_received",
            payload: {
              _id: detail.conversation._id,
              conversation_id: detail.conversation._id,
              text: detail.message.text || detail.conversation.last_message_text,
              conversation: detail.conversation,
              client: detail.conversation.client,
              contact_name: detail.conversation.contact_name,
              contact_picture_url: detail.conversation.contact_picture_url,
              contact_picture: detail.conversation.contact_picture
            },
            description: detail.message.text || "Nova mensagem recebida no WhatsApp",
            created_at: new Date(),
            readed: false
          },
          ...this.notifications
        ];
      }
      this.listNotifications();
    },
    listNotifications() {
      this.$run("notifications/list-my-notifications").then(res => {
        const remoteNotifications = Array.isArray(res.data) ? res.data : (res.data.docs || []);
        const localNotifications = this.notifications.filter(notification =>
          String(notification._id || "").startsWith("local-")
        );
        this.notifications = [
          ...localNotifications,
          ...remoteNotifications.filter(notification =>
            !localNotifications.some(localNotification => String(localNotification._id) === String(notification._id))
          )
        ];
      });
    },
    getLinkNotify(notification) {
      const types = {
        invoice_payment: {
          title: "Pagamento de conta",
          link: `/invoice?t_id=${notification.payload._id}`
        },
        new_comment: {
          title: "Novo comentÃ¡rio",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        employee_balance_added: {
          title: "SalÃ¡rio adicionado manualmente",
          link: `/funcionarios?f_id=${
            notification.client ? notification.client._id : ""
          }&type=salario&e_id=${notification.payload._id}`
        },
        employee_balance_withdraw: {
          title: "Vale emitido",
          link: `/funcionarios?f_id=${notification.payload._id}&type=vale&extra=${notification.payload._id}`
        },
        sale_updated: {
          title: "Venda atualizada",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        sale_approval_updated: {
          title: "Aprovação do orçamento atualizada",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        whatsapp_message_received: {
          title: "Mensagem WhatsApp",
          link: `/whatsapp-atendimento?conversationId=${(notification.payload && (notification.payload.conversation_id || notification.payload._id)) || ""}`
        },
        internal_chat_message: {
          title: "Mensagem interna",
          link: `/whatsapp-atendimento?internalUserId=${(notification.payload && notification.payload.sender_id) || ""}`
        },
        stock_up: {
          title: "Estoque aumentado",
          link: `/insumos?p_id=${notification.payload._id}&type=estoque`
        },
        stock_down: {
          title: "Estoque diminuido",
          link: `/insumos?p_id=${notification.payload._id}&type=estoque`
        },
        stock_low: {
          title: "Estoque baixo",
          link: `/insumos?p_id=${notification.payload._id}&type=estoque`
        },
        box_closed: {
          title: "Caixa fechado",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        box_opened: {
          title: "Caixa aberto",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        new_payment: {
          title: "Pagamento Recebido",
          link: `/gestordepedidos?t_id=${notification.payload._id}`
        },
        new_comment_external_movimentation: {
          title: "Novo comentÃ¡rio",
          link: `/agenda?t_id=${notification.payload._id}`
        },
        new_external_movimentation: {
          title: "Novo agendamento",
          link: `/agenda?e_id=${notification.payload._id}`
        },
        new_external_movimentation_viewed: {
          title: "O agendamento foi visualizado",
          link: `/agenda?e_id=${notification.payload._id}`
        },
        external_movimentation_updated: {
          title: "Um agendamento foi atualizado",
          link: `/minha-agenda?e_id=${notification.payload._id}`
        },
        delivery_confirmation: {
          title: "ConfirmaÃ§Ã£o de entrega",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        delivery_confirmation_whatsapp_queued: {
          title: "ConfirmaÃ§Ã£o de entrega enviada",
          link: `/whatsapp-atendimento`
        },
        delivery_confirmation_whatsapp_pending: {
          title: "ConfirmaÃ§Ã£o de entrega pendente",
          link: `/gestordepedidos/venda/${notification.payload.transaction_id || notification.payload._id}`
        },
        assembly_offer_whatsapp_pending: {
          title: "Oferta de montagem pendente",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        collection_whatsapp_pending: {
          title: "Cobrança pendente",
          link: `/cobranca`
        },
        collection_contact_registered: {
          title: "Contato de Cobrança registrado",
          link: `/cobranca`
        },
        whatsapp_delivery_response: {
          title: "Resposta sobre entrega",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        whatsapp_assembly_declined: {
          title: "Montagem recusada",
          link: `/entregas?event=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        whatsapp_assembly_requested: {
          title: "Montagem solicitada",
          link: `/agenda?e_id=${notification.payload.external_movimentation_id || notification.payload._id}`
        },
        whatsapp_approval_response: {
          title: "Resposta de aprovaÃ§Ã£o",
          link: `/gestordepedidos/venda/${notification.payload.transaction_id || notification.payload._id}`
        },
        whatsapp_collection_response: {
          title: "Resposta de Cobrança",
          link: `/cobranca`
        },
        whatsapp_company_contact_notice: {
          title: "Aviso de contato da empresa",
          link: `/whatsapp-atendimento`
        },
        transaction_unsigned: {
          title: "Registro da conferência de caixa foi Cancelado",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        transaction_signed: {
          title: "Registro da conferência de caixa foi Aprovado",
          link: `/acompanhamento-de-caixa?c_id=${notification.payload._id}`
        },
        seller_signup: {
          title: "Um vendedor se cadastrou",
          link: `https://erp.stonepro.com.br/#/sellers?c_id=${notification.payload._id}`
        },
        "signature-flow-initiated": {
          title: "Um novo cliente se cadastrou",
          link: `https://erp.stonepro.com.br/#/funcionarios?c_id=${notification.payload._id}`
        },
        "signature-flow-progress": {
          title: "Um cliente criou sua loja",
          link: `https://erp.stonepro.com.br/#/funcionarios?c_id=${notification.payload._id}`
        }
      };
      return types[notification.type];
    },
    markNotificationAsReaded(notification) {
      this.$run("notifications/mark-as-readed", { _id: notification._id }).then(
        res => {
          this.listNotifications();
        }
      );
    },
    mountDriver() {
      this.driver = driver({
        showProgress: false,
        allowClose: true,
        steps: [
          {
            element: "#notifications-container",
            popover: {
              title: "Bem vindo ao StonePro",
              description:
                "Vamos guiar vocÃª atÃ© a criaÃ§Ã£o do seu primeiro orÃ§amento, vamos lÃ¡?.",
              // doneBtnText: "Sair",
              // allowClose: true,
              // closeBtnText: "Depois",
              nextBtnText: "Vamos ðŸš€",
              prevBtnText: ""
            }
          },
          {
            element: "#container-menus",
            allowClose: false,
            popover: {
              title: "ComposiÃ§Ã£o dos menus",
              description:
                "Na dashboard vocÃª pode navegar pelas principais funcionalidades do StonePro, cada tela tem um botÃ£o para voltar a tela anterior",
              doneBtnText: "Sair",
              closeBtnText: "Fechar",
              nextBtnText: "Entendi",
              prevBtnText: "Passo Anterior"
            }
          },
          {
            element: "#Produtos",
            popover: {
              title: "Antes de criar um orÃ§amento",
              description:
                "Antes de criar um orÃ§amento, vocÃª precisa cadastrar os tipos de produtos que vocÃª faz, pra isso, clique no menu 'Produtos'",
              showButtons: []
            }
          }
        ]
      });
    },
    driverStart() {
      try {
        // this.driver.destroy();
        this.driver.drive();
        this.initActiveNextStep(this);
      } catch (e) {
        // console.log("driver jÃ¡ foi criado");
      }
    },
    nextStep() {
      this.driver.moveNext();
    },
    verifyGuideState() {
      if (localStorage.guide == "want") {
        const self = this;
        this.driverStart();
        document
          .querySelector(".active-next-step")
          .addEventListener("click", self.nextStep.bind(self));
      }
    }
  },
  watch: {
    dashboardDeliveryMapSignature() {
      this.scheduleDashboardDeliveryMapRender();
    },
    dark() {
      this.scheduleDashboardDeliveryMapRender(true);
    }
  },
  created() {
    this.verifyTheme();
    this.loadDashboardWidgets();
    this.loadDashboardPaymentConfig();
    this.listar_gestordepedidos();
    this.listNotifications();
    this.loadDashboardDeliveryData();
    this.loadDashboardMapCenter();
    this.mountDriver();
  },
  beforeDestroy() {
    const self = this;
    const activeNextStep = document.querySelector(".active-next-step");
    if (activeNextStep) {
      activeNextStep.removeEventListener("click", self.nextStep.bind(self));
    }
    window.removeEventListener("stonepro:whatsapp-message", this.dashboardRealtimeHandler);
    window.removeEventListener("stonepro:whatsapp-refresh", this.dashboardRealtimeHandler);
    window.removeEventListener("stonepro:sale-updated", this.dashboardRealtimeHandler);
    window.removeEventListener("stonepro:internal-chat-message", this.dashboardRealtimeHandler);
    window.removeEventListener("stonepro:external-movimentation-updated", this.dashboardRealtimeHandler);
    if (this.dashboardGrid) {
      this.dashboardGrid.destroy(false);
      this.dashboardGrid = null;
    }
    clearTimeout(this.dashboardDeliveryMapRenderTimer);
    this.dashboardDeliveryMarkers.forEach(marker => marker.remove());
    this.dashboardDeliveryMarkers = [];
    this.dashboardDeliveryRouteLayers.forEach(layer => layer.remove());
    this.dashboardDeliveryRouteLayers = [];
    if (this.dashboardDeliveryMap) {
      this.dashboardDeliveryMap.remove();
      this.dashboardDeliveryMap = null;
    }
    clearTimeout(this.dashboardWidgetFeedbackTimer);
  },
  mounted() {
    setTimeout(() => {
      this.showWelcome = false;
    }, 3000);
    //reset listenar
    this.testPing();
    this.listNotifications();
    this.dashboardRealtimeHandler = event => this.handleDashboardRealtime(event);
    window.addEventListener("stonepro:whatsapp-message", this.dashboardRealtimeHandler);
    window.addEventListener("stonepro:whatsapp-refresh", this.dashboardRealtimeHandler);
    window.addEventListener("stonepro:sale-updated", this.dashboardRealtimeHandler);
    window.addEventListener("stonepro:internal-chat-message", this.dashboardRealtimeHandler);
    window.addEventListener("stonepro:external-movimentation-updated", this.dashboardRealtimeHandler);
    this.initDashboardGrid();
    this.requestDashboardBrowserLocation();
    this.scheduleDashboardDeliveryMapRender();
    this.listar_funcionarios();
    this.listar_external_movimentations();
    if (!sessionStorage.nt || sessionStorage.nt) {
      if (Notification.permission === "granted") {
        sessionStorage.nt = "ok";
        const messaging = getMessaging();
        getToken(messaging, {
          vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY
        }).then(currentToken => {
          if (currentToken) {
            this.$run("notifications/register-token", {
              notification_token: currentToken
            }).catch(res => {
              console.log("erro no token", res);
            });
          } else {
            alert(
              "vocÃª recusou o envio de notificaÃ§Ãµes, para receber nossos fluxos de notificaÃ§Ã£o, acesse as configuraÃ§Ãµes do seu navegador e permita o envio de notificaÃ§Ãµes."
            );
          }
          onMessage(messaging, payload => {
            const { data } = payload;
            this.listNotifications();
            this.notification_sound();
          });
        });
      } else {
        Notification.requestPermission()
          .then(async permission => {
            if (permission === "granted") {
              const messaging = getMessaging();
              getToken(messaging, {
                vapidKey: process.env.VUE_APP_FIREBASE_VAPID_KEY
              }).then(currentToken => {
                if (currentToken) {
                  this.$run("notifications/register-token", {
                    notification_token: currentToken
                  })
                    .then(() => {
                      sessionStorage.nt = "ok";
                    })
                    .catch(res => {
                      console.log("erro no token", res);
                    });
                } else {
                  alert(
                    "vocÃª recusou o envio de notificaÃ§Ãµes, para receber nossos fluxos de notificaÃ§Ã£o, acesse as configuraÃ§Ãµes do seu navegador e permita o envio de notificaÃ§Ãµes."
                  );
                }
                onMessage(messaging, payload => {
                  this.listNotifications();
                  this.notification_sound();
                });
              });
            }
          })
          .catch(err => {
            console.log("wtf", err);
          });
      }
    }
  }
};
</script>

<style>
.dashboard-company-logo {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(7, 94, 84, 0.14);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.10);
  vertical-align: middle;
}
.dashboard-appbar-toolbar {
  align-items: center;
  display: flex;
  gap: 8px;
  justify-content: center;
  min-width: 0;
  width: 100%;
}
.dashboard-appbar-toolbar-btn {
  border-radius: 999px !important;
  height: 32px !important;
  letter-spacing: 0;
  padding: 0 12px !important;
  text-transform: none !important;
  white-space: nowrap;
}
.dashboard-appbar-theme-switch {
  flex: 0 0 auto;
  margin: 0 0 0 2px !important;
  padding: 0 !important;
}
.dashboard-appbar-theme-switch .v-input__slot {
  margin-bottom: 0 !important;
}
.dashboard-appbar-theme-switch .v-label {
  font-size: 12px;
  margin-left: 2px;
}
.empty {
  transition: transform 0.3s ease;
}
.empty:hover {
  transform: scale(1.2);
}
.message {
  width: 150px;
  /* animation: digitando 0.2s ease; */
  white-space: nowrap;
  overflow: hidden;

  position: absolute;
  top: 50%;
  left: 45%;
  /* transform: translate(-50%, -50%); */
}

@keyframes digitando {
  from {
    width: 0;
  }
}

.fonte-color {
  color: #075059;
}
.icon-show-balance {
  display: flex;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 1px dashed #000;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.divider-balance {
  width: 100%;
  height: 1px;
  border-top: 1px dashed #000;
}
.unreaded-notification {
}
.dashboard-welcome-card {
  display: flex;
  align-items: center;
  gap: 16px;
  width: calc(100% - 16px);
  margin: 10px 8px 8px;
  padding: 18px;
  border-radius: 22px;
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, .18), transparent 34%),
    linear-gradient(135deg, #f7fbf8 0%, #edf7f1 100%);
  border: 1px solid rgba(7, 80, 89, .08);
  color: #173b33;
  box-shadow: 0 18px 42px rgba(7, 80, 89, .08);
}
.dashboard-welcome-card.dark {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, .18), transparent 34%),
    linear-gradient(135deg, #111b21 0%, #182229 100%);
  border-color: rgba(155, 231, 189, .08);
  color: #eef4f1;
  box-shadow: 0 18px 42px rgba(0, 0, 0, .24);
}
.dashboard-welcome-copy {
  display: flex;
  align-items: center;
  min-width: 0;
}
.dashboard-grid-stack {
  width: 100%;
  padding: 0 8px 40px;
  min-height: 420px;
}
.dashboard-grid-stack .grid-stack-item {
  min-width: 260px;
  min-height: 208px;
}
.dashboard-grid-stack .grid-stack-item-content {
  border-radius: 18px;
  inset: 7px !important;
  min-width: 0;
  min-height: 194px;
  overflow: hidden !important;
}
.dashboard-grid-stack .dashboard-modern-card {
  min-height: 194px;
}
.dashboard-grid-stack.grid-stack-static .grid-stack-item-content {
  cursor: default !important;
}
.dashboard-grid-stack .ui-resizable-handle {
  display: none !important;
  position: absolute !important;
  opacity: .85;
  z-index: 12;
  pointer-events: auto;
}
.dashboard-grid-stack .ui-resizable-se {
  right: 10px !important;
  bottom: 10px !important;
  width: 18px !important;
  height: 18px !important;
}
.dashboard-grid-stack.editing .ui-resizable-se {
  display: block !important;
}
.dashboard-grid-stack .ui-resizable-se::after {
  content: "";
  display: block;
  width: 12px;
  height: 12px;
  border-right: 3px solid rgba(37, 211, 102, .75);
  border-bottom: 3px solid rgba(37, 211, 102, .75);
  border-radius: 2px;
}
.dashboard-widget-toolbar {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 8px;
  margin-bottom: 8px;
  color: #173b33;
}
.dashboard-widget-toolbar.dark {
  color: #eef4f1;
}
.dashboard-widget-menu-anchor {
  height: 0;
  overflow: visible;
  pointer-events: none;
  width: 0;
}
.dashboard-widget-menu-anchor .v-menu__content,
.dashboard-widget-menu-anchor .dashboard-widget-menu {
  pointer-events: auto;
}
.dashboard-widget-menu-anchor > .spacer,
.dashboard-widget-menu-anchor .v-menu > .v-btn,
.dashboard-widget-menu-anchor .v-menu__activator {
  display: none !important;
}
.dashboard-widget-menu {
  border-radius: 16px !important;
  min-width: 310px;
  box-shadow: 0 18px 60px rgba(0, 0, 0, .22) !important;
}
.dashboard-widget-menu-hint {
  margin: 4px 6px 10px;
  padding: 10px 12px;
  border-radius: 12px;
  background: rgba(37, 211, 102, .1);
  color: #59736a;
  font-size: 12px;
  line-height: 1.35;
}
.dashboard-add-widget-item {
  border-radius: 12px;
  transition: background .18s ease, transform .18s ease;
}
.dashboard-add-widget-item:hover {
  background: rgba(37, 211, 102, .1) !important;
  transform: translateX(2px);
}
.dashboard-widget-feedback {
  position: fixed;
  top: 84px;
  right: 24px;
  z-index: 20;
  display: inline-flex;
  align-items: center;
  pointer-events: none;
  padding: 10px 14px;
  border-radius: 999px;
  background: #e9fbef;
  color: #075e54;
  box-shadow: 0 12px 30px rgba(7, 80, 89, .14);
  font-size: 13px;
}
.dashboard-feedback-enter-active,
.dashboard-feedback-leave-active {
  transition: .25s ease;
}
.dashboard-feedback-enter,
.dashboard-feedback-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}
.dashboard-modern-card {
  border-radius: 18px !important;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, .08), transparent 32%),
    #f7faf8 !important;
  border: 1px solid rgba(7, 80, 89, .14);
  box-shadow: 0 18px 48px rgba(7, 80, 89, .16), 0 2px 8px rgba(7, 80, 89, .08) !important;
}
.dashboard-modern-card.dark {
  background:
    radial-gradient(circle at top left, rgba(37, 211, 102, .12), transparent 32%),
    #111b21 !important;
  border-color: rgba(155, 231, 189, .1);
  box-shadow: 0 16px 42px rgba(0, 0, 0, .22) !important;
}
.dashboard-modern-card.dashboard-widget-shortcuts,
.dashboard-modern-card.dashboard-widget-todaySales {
  contain: layout paint;
}
.dashboard-card-header {
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  cursor: default;
  color: #173b33;
}
.dashboard-modern-card.dark .dashboard-card-header {
  color: #eef4f1;
}
.grid-stack:not(.grid-stack-static) .dashboard-card-header {
  cursor: move;
}
.dashboard-whatsapp-status {
  margin: 10px 0;
  padding: 10px;
  border-radius: 14px;
  background: rgba(37, 211, 102, .1);
}
.dashboard-card-scroll {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-right: 4px;
}
.dashboard-card-scroll,
.dashboard-shortcuts-grid,
.dashboard-chart-shell {
  scrollbar-width: thin;
  scrollbar-color: #b9c9c1 rgba(7, 80, 89, .08);
}
.dashboard-card-scroll::-webkit-scrollbar,
.dashboard-shortcuts-grid::-webkit-scrollbar,
.dashboard-chart-shell::-webkit-scrollbar {
  width: 9px;
  height: 9px;
}
.dashboard-card-scroll::-webkit-scrollbar-track,
.dashboard-shortcuts-grid::-webkit-scrollbar-track,
.dashboard-chart-shell::-webkit-scrollbar-track {
  background: rgba(7, 80, 89, .08);
  border-radius: 999px;
}
.dashboard-card-scroll::-webkit-scrollbar-thumb,
.dashboard-shortcuts-grid::-webkit-scrollbar-thumb,
.dashboard-chart-shell::-webkit-scrollbar-thumb {
  background: #b9c9c1;
  border: 2px solid transparent;
  border-radius: 999px;
  background-clip: padding-box;
}
.dashboard-card-scroll::-webkit-scrollbar-thumb:hover,
.dashboard-shortcuts-grid::-webkit-scrollbar-thumb:hover,
.dashboard-chart-shell::-webkit-scrollbar-thumb:hover {
  background: #8ea39a;
  background-clip: padding-box;
}
.dashboard-modern-card.dark .dashboard-card-scroll,
.dashboard-modern-card.dark .dashboard-shortcuts-grid,
.dashboard-modern-card.dark .dashboard-chart-shell {
  scrollbar-color: #40515a #111b21;
}
.dashboard-modern-card.dark .dashboard-card-scroll::-webkit-scrollbar-track,
.dashboard-modern-card.dark .dashboard-shortcuts-grid::-webkit-scrollbar-track,
.dashboard-modern-card.dark .dashboard-chart-shell::-webkit-scrollbar-track {
  background: #111b21;
}
.dashboard-modern-card.dark .dashboard-card-scroll::-webkit-scrollbar-thumb,
.dashboard-modern-card.dark .dashboard-shortcuts-grid::-webkit-scrollbar-thumb,
.dashboard-modern-card.dark .dashboard-chart-shell::-webkit-scrollbar-thumb {
  background: #40515a;
  border: 2px solid #111b21;
}
.dashboard-modern-card.dark .dashboard-card-scroll::-webkit-scrollbar-thumb:hover,
.dashboard-modern-card.dark .dashboard-shortcuts-grid::-webkit-scrollbar-thumb:hover,
.dashboard-modern-card.dark .dashboard-chart-shell::-webkit-scrollbar-thumb:hover {
  background: #58707a;
}
.dashboard-shortcuts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(104px, 1fr));
  align-content: start;
  gap: 10px;
  flex: 1 1 auto;
  min-height: 0;
  overflow: auto;
  padding-right: 4px;
}
.dashboard-shortcut-card {
  display: flex;
  min-height: 96px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 9px;
  border: 0;
  border-radius: 16px;
  background: rgba(255, 255, 255, .88);
  color: #173b33;
  font-family: inherit;
  transition: transform .18s ease, box-shadow .18s ease;
}
.dashboard-shortcut-card span {
  color: inherit;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.15;
  max-width: 100%;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
}
.dashboard-shortcut-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 14px 26px rgba(7, 80, 89, .12);
}
.dashboard-modern-card.dark .dashboard-shortcut-card {
  background: #182229;
  color: #eef4f1;
}
.dashboard-modern-card:not(.dark) .dashboard-sale-row,
.dashboard-modern-card:not(.dark) .dashboard-shortcut-card {
  border: 1px solid rgba(7, 80, 89, .08);
  box-shadow: 0 8px 18px rgba(7, 80, 89, .06);
}
.dashboard-modern-card.dark .dashboard-sale-row,
.dashboard-modern-card.dark .dashboard-shortcut-card {
  border: 1px solid rgba(155, 231, 189, .08);
}
.dashboard-chart-shell {
  height: calc(100% - 58px);
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 4px 0 8px;
  min-height: 0;
}
.dashboard-chart-shell canvas {
  max-width: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
  height: 100% !important;
  object-fit: contain;
}
.dashboard-payment-widget {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  gap: 8px;
  min-height: 0;
  overflow: auto;
}
.dashboard-payment-chart {
  flex: 1 1 170px;
  min-height: 150px;
  position: relative;
}
.dashboard-payment-chart canvas {
  height: 100% !important;
  max-height: 100% !important;
  width: 100% !important;
}
.dashboard-payment-methods {
  display: grid;
  flex: 0 0 auto;
  gap: 6px;
  grid-template-columns: repeat(auto-fit, minmax(145px, 1fr));
  max-height: 92px;
  overflow: auto;
  padding-right: 3px;
}
.dashboard-payment-method {
  background: rgba(7, 80, 89, .06);
  border-radius: 9px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
  padding: 6px 8px;
}
.dashboard-payment-method-name {
  align-items: center;
  display: flex;
  gap: 6px;
  min-width: 0;
}
.dashboard-payment-method-name i {
  border-radius: 50%;
  flex: 0 0 auto;
  height: 8px;
  width: 8px;
}
.dashboard-payment-method-name span,
.dashboard-payment-method small {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashboard-payment-method-name span {
  font-size: 11px;
  font-weight: 700;
}
.dashboard-payment-method small {
  color: #6a7f76;
  font-size: 10px;
}
.dashboard-modern-card.dark .dashboard-payment-method {
  background: rgba(155, 231, 189, .08);
}
.dashboard-modern-card.dark .dashboard-payment-method small {
  color: #9bb4aa;
}
.dashboard-sale-row,
.dashboard-event-row,
.dashboard-rank-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  border-radius: 14px;
  padding: 11px 12px;
  background: rgba(255, 255, 255, .86);
  color: #173b33;
  text-align: left;
}
.dashboard-event-row {
  grid-template-columns: 28px minmax(0, 1fr) auto;
}
.dashboard-rank-row {
  grid-template-columns: 38px minmax(0, 1fr) 38px;
}
.dashboard-sale-row strong,
.dashboard-event-row strong,
.dashboard-rank-row strong {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashboard-sale-row span,
.dashboard-event-row span,
.dashboard-rank-row span {
  display: block;
  color: #6a7f76;
  font-size: 11px;
}
.dashboard-modern-card.dark .dashboard-sale-row,
.dashboard-modern-card.dark .dashboard-event-row,
.dashboard-modern-card.dark .dashboard-rank-row {
  background: #182229;
  color: #eef4f1;
}
.dashboard-modern-card.dark .dashboard-sale-row span,
.dashboard-modern-card.dark .dashboard-event-row span,
.dashboard-modern-card.dark .dashboard-rank-row span {
  color: #8ea39a;
}
.dashboard-notification-row {
  display: grid;
  grid-template-columns: 42px minmax(0, 1fr) auto;
  align-items: center;
  gap: 10px;
  width: 100%;
  border: 0;
  border-radius: 13px;
  padding: 10px 12px;
  background: rgba(255, 255, 255, .86);
  color: #173b33;
  text-align: left;
  transition: transform .18s ease, box-shadow .18s ease, background .18s ease;
}
.dashboard-notification-row:hover {
  transform: translateY(-1px);
  box-shadow: 0 10px 24px rgba(7, 80, 89, .1);
}
.dashboard-notification-row.whatsapp {
  background: rgba(255, 255, 255, .9);
}
.dashboard-notification-avatar {
  overflow: hidden;
}
.dashboard-notification-copy {
  min-width: 0;
}
.dashboard-notification-copy strong,
.dashboard-notification-copy span {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashboard-notification-copy strong {
  color: inherit;
  font-size: 13px;
  line-height: 1.2;
}
.dashboard-notification-copy span {
  color: #6a7f76;
  font-size: 11px;
  line-height: 1.25;
  margin-top: 2px;
}
.dashboard-notification-row small {
  color: #5d746c;
  font-size: 10px;
  white-space: nowrap;
}
.dashboard-modern-card.dark .dashboard-notification-row {
  background: #182229;
  color: #e7f4ee;
}
.dashboard-modern-card.dark .dashboard-notification-copy span {
  color: #8ea39a;
}
.dashboard-modern-card.dark .dashboard-notification-row small {
  color: #8ea39a;
}
.dashboard-empty-state {
  display: flex;
  min-height: 170px;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  color: #7c8f87;
  border: 1px dashed rgba(7, 80, 89, .18);
  border-radius: 14px;
}
.deliveries-widget-map-only {
  padding-right: 0;
}
.deliveries-map-filters {
  display: grid;
  gap: 6px;
  grid-template-columns: repeat(3, minmax(118px, 150px));
  left: auto;
  max-width: calc(100% - 76px);
  position: absolute;
  right: 12px;
  top: 12px;
  z-index: 900;
}
.dashboard-modern-card.dark .deliveries-map-filters {
  background: transparent;
  border-color: transparent;
}
.deliveries-map-filters ::v-deep .v-input {
  font-size: 12px;
}
.deliveries-map-filters ::v-deep .v-input__slot {
  background: rgba(255, 255, 255, .96) !important;
  border: 1px solid rgba(7, 80, 89, .14) !important;
  border-radius: 999px !important;
  box-shadow: 0 8px 20px rgba(7, 80, 89, .12) !important;
  min-height: 36px !important;
  padding: 0 10px !important;
}
.deliveries-map-filters ::v-deep .v-text-field--filled .v-label,
.deliveries-map-filters ::v-deep .v-select__selection,
.deliveries-map-filters ::v-deep input {
  color: #173b33 !important;
  font-size: 12px;
}
.deliveries-map-filters ::v-deep .v-label {
  color: #5e7269 !important;
}
.deliveries-map-filters ::v-deep .v-text-field--filled .v-label {
  top: 9px !important;
}
.deliveries-map-filters ::v-deep .v-text-field--filled.v-input--is-focused .v-label,
.deliveries-map-filters ::v-deep .v-text-field--filled.v-input--has-state .v-label,
.deliveries-map-filters ::v-deep .v-text-field--filled.v-input--is-dirty .v-label {
  transform: translateY(-13px) scale(.75);
}
.deliveries-map-filters ::v-deep .v-input__append-inner,
.deliveries-map-filters ::v-deep .v-input__prepend-inner {
  margin-top: 6px !important;
}
.dashboard-modern-card.dark .deliveries-map-filters ::v-deep .v-input__slot {
  background: rgba(16, 31, 36, .96) !important;
  border-color: #244149 !important;
  box-shadow: 0 8px 20px rgba(0, 0, 0, .22) !important;
}
.dashboard-modern-card.dark .deliveries-map-filters ::v-deep .v-select__selection,
.dashboard-modern-card.dark .deliveries-map-filters ::v-deep input {
  color: #e7f4ee !important;
}
.dashboard-modern-card.dark .deliveries-map-filters ::v-deep .v-label {
  color: #8ea39a !important;
}
.deliveries-map-board {
  background: #dfeae4;
  border: 1px solid rgba(7, 80, 89, .14);
  border-radius: 8px;
  height: 100%;
  min-height: 520px;
  overflow: hidden;
  position: relative;
}
.deliveries-map-board.dark {
  background: #1f2d31;
  border-color: rgba(56, 86, 90, .58);
}
.deliveries-leaflet-map {
  height: 100%;
  width: 100%;
}
.deliveries-map-board.dark .leaflet-container {
  background: #233136;
}
.deliveries-map-board.dark .leaflet-tile-pane {
  filter: brightness(.82) contrast(.96) saturate(.72);
}
.deliveries-map-board.dark .leaflet-control-zoom {
  border: 1px solid rgba(80, 111, 111, .28);
  border-radius: 10px;
  box-shadow: 0 10px 20px rgba(18, 34, 37, .24);
  overflow: hidden;
}
.deliveries-map-board.dark .leaflet-control-zoom a {
  background: rgba(244, 248, 245, .94);
  border-bottom-color: rgba(25, 49, 52, .14);
  color: #1f3d3e;
}
.deliveries-map-board.dark .leaflet-control-zoom a:hover {
  background: #ffffff;
  color: #075e54;
}
.deliveries-map-board.dark .leaflet-control-attribution {
  background: rgba(244, 248, 245, .82);
  color: #496063;
}
.deliveries-map-board.dark .leaflet-control-attribution a {
  color: #075e54;
}
.deliveries-map-board.dark .leaflet-popup-content-wrapper,
.deliveries-map-board.dark .leaflet-popup-tip {
  background: #f7faf8;
  color: #173b33;
  box-shadow: 0 16px 34px rgba(14, 36, 38, .24);
}
.deliveries-map-board.dark .leaflet-popup-close-button {
  color: #52645d;
}
.deliveries-map-board.dark .leaflet-popup-close-button:hover {
  color: #075e54;
}
.deliveries-map-loading {
  align-items: center;
  background: rgba(255, 255, 255, .72);
  color: #52645d;
  display: flex;
  flex-direction: column;
  gap: 8px;
  inset: 0;
  justify-content: center;
  position: absolute;
  pointer-events: none;
  z-index: 4;
}
.deliveries-map-board.dark .deliveries-map-loading {
  background: rgba(25, 42, 45, .54);
  color: #d8e8e2;
}
.deliveries-map-legend {
  background: rgba(255, 255, 255, .92);
  border: 1px solid rgba(7, 80, 89, .12);
  border-radius: 999px;
  bottom: 12px;
  box-shadow: 0 10px 24px rgba(7, 80, 89, .12);
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  left: 12px;
  padding: 7px 10px;
  position: absolute;
  z-index: 650;
}
.dashboard-modern-card.dark .deliveries-map-legend {
  background: rgba(247, 250, 248, .9);
  border-color: rgba(24, 70, 72, .16);
}
.deliveries-map-legend span {
  align-items: center;
  color: #6a7f76;
  display: inline-flex;
  font-size: 11px;
  gap: 5px;
}
.dashboard-modern-card.dark .deliveries-map-legend span {
  color: #48615b;
}
.deliveries-map-legend i {
  border-radius: 50%;
  display: inline-block;
  height: 9px;
  width: 9px;
}
.dashboard-delivery-info-window {
  color: #173b33;
  display: grid;
  gap: 4px;
  max-width: 280px;
}
.dashboard-delivery-info-window strong,
.dashboard-delivery-info-window span,
.dashboard-delivery-info-window small {
  display: block;
}
.dashboard-delivery-info-window ul {
  border-top: 1px solid rgba(7, 80, 89, .12);
  display: grid;
  gap: 7px;
  list-style: none;
  margin: 8px 0 0;
  max-height: 168px;
  overflow: auto;
  padding: 8px 0 0;
}
.dashboard-delivery-info-window li {
  background: rgba(7, 80, 89, .06);
  border-radius: 8px;
  display: grid;
  gap: 2px;
  padding: 7px 8px;
}
.dashboard-delivery-info-window li b {
  color: #075e54;
  font-size: 10px;
  text-transform: uppercase;
}
.dashboard-delivery-info-route {
  align-items: center;
  display: flex;
  gap: 6px;
  margin-top: 4px;
}
.dashboard-delivery-info-route span {
  background: rgba(7, 80, 89, .08);
  border-radius: 999px;
  color: #075e54;
  display: inline-flex;
  font-size: 11px;
  font-weight: 700;
  padding: 3px 7px;
}
.deliveries-map-board.dark .dashboard-delivery-info-window {
  color: #173b33;
}
.deliveries-map-board.dark .dashboard-delivery-info-window ul {
  border-top-color: rgba(7, 80, 89, .12);
}
.deliveries-map-board.dark .dashboard-delivery-info-window li {
  background: rgba(7, 80, 89, .06);
}
.deliveries-map-board.dark .dashboard-delivery-info-window li b {
  color: #075e54;
}
.deliveries-map-board.dark .dashboard-delivery-info-route span {
  background: rgba(7, 80, 89, .08);
  color: #075e54;
}
::v-deep .dashboard-delivery-leaflet-marker {
  background: transparent;
  border: 0;
}
::v-deep .dashboard-delivery-marker {
  height: 62px;
  position: relative;
  width: 52px;
}
::v-deep .dashboard-delivery-marker-shape {
  filter: drop-shadow(0 10px 16px rgba(7, 80, 89, .28));
  height: 62px;
  width: 52px;
}
::v-deep .dashboard-delivery-marker-icon {
  left: 15px;
  position: absolute;
  top: 15px;
  z-index: 2;
}
::v-deep .dashboard-delivery-marker-icon svg {
  height: 22px;
  width: 22px;
}
@media(max-width: 760px) {
  .deliveries-map-filters {
    grid-template-columns: 1fr;
    left: 56px;
    max-height: 42%;
    max-width: calc(100% - 68px);
    overflow: auto;
    right: 12px;
  }
  .deliveries-map-board {
    min-height: 560px;
  }
  .deliveries-map-legend {
    border-radius: 8px;
    bottom: 10px;
    max-width: calc(100% - 20px);
  }
}
.deliveries-widget .dashboard-event-row div small {
  color: #6a7f76;
  display: block;
  font-size: 10px;
  margin-top: 2px;
}
.deliveries-metrics {
  display: grid;
  gap: 10px;
  grid-template-columns: 1fr 1fr;
}
.deliveries-metrics div {
  background: rgba(255, 255, 255, .88);
  border: 1px solid rgba(7, 80, 89, .12);
  border-radius: 8px;
  padding: 12px;
}
.deliveries-metrics span,
.deliveries-metrics small {
  color: #6a7f76;
  display: block;
  font-size: 11px;
}
.deliveries-metrics strong {
  color: #173b33;
  display: block;
  font-size: 18px;
  line-height: 1.25;
}
.dashboard-modern-card.dark .deliveries-metrics div {
  background: #182229;
  border-color: #26343c;
}
.dashboard-modern-card.dark .deliveries-metrics strong {
  color: #e7f4ee;
}
.dashboard-modern-card.dark .deliveries-metrics span,
.dashboard-modern-card.dark .deliveries-metrics small,
.dashboard-modern-card.dark .deliveries-widget .dashboard-event-row div small {
  color: #8ea39a;
}
.dashboard-whatsapp-updates {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 12px 0;
  padding: 12px;
  border-radius: 14px;
  background: #eefaf3;
  border: 1px solid rgba(37, 211, 102, .22);
}
.dashboard-whatsapp-header {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #075e54;
}
.dashboard-whatsapp-item {
  display: grid;
  grid-template-columns: 22px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 0;
  border-radius: 10px;
  padding: 9px 10px;
  background: rgba(255,255,255,.86);
  color: #173b33;
  text-align: left;
}
.dashboard-whatsapp-item span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.dashboard-whatsapp-item small {
  color: #5d746c;
  white-space: nowrap;
}
.dashboard-whatsapp-updates-dark {
  background: #0b2f28;
  border-color: rgba(37, 211, 102, .18);
}
.dashboard-whatsapp-updates-dark .dashboard-whatsapp-header {
  color: #9be7bd;
}
.dashboard-whatsapp-updates-dark .dashboard-whatsapp-item {
  background: #111b21;
  color: #e7f4ee;
}
.dashboard-whatsapp-updates-dark .dashboard-whatsapp-item small {
  color: #8ea39a;
}
.item-menu-mini {
  transition: transform 0.3s ease;
}
.item-menu-mini:hover {
  transform: scale(1.1);
  font-weight: bold;
}
@keyframes blinker {
  50% {
    opacity: 0;
    margin-top: 5px;
  }
}
</style>
